// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tw-container{
  width:100%
}

@media(min-width: 640px){
  .tw-container{
    max-width:640px
  }
}

@media(min-width: 768px){
  .tw-container{
    max-width:768px
  }
}

@media(min-width: 1024px){
  .tw-container{
    max-width:1024px
  }
}

@media(min-width: 1280px){
  .tw-container{
    max-width:1280px
  }
}

@media(min-width: 1366px){
  .tw-container{
    max-width:1366px
  }
}

.tw-space-y-4>:not(template)~:not(template){
  --space-y-reverse: 0;
  margin-top:calc(16px*(1 - var(--space-y-reverse)));
  margin-bottom:calc(16px*var(--space-y-reverse))
}

.tw-bg-transparent{
  background-color:rgba(255,255,255,.001)
}

.tw-bg-black{
  --bg-opacity: 1;
  background-color:#000;
  background-color:rgba(0, 0, 0, var(--bg-opacity))
}

.tw-bg-white{
  --bg-opacity: 1;
  background-color:#fff;
  background-color:rgba(255, 255, 255, var(--bg-opacity))
}

.tw-bg-primary{
  --bg-opacity: 1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity))
}

.tw-bg-primaryLighter{
  --bg-opacity: 1;
  background-color:#35c5ad;
  background-color:rgba(53, 197, 173, var(--bg-opacity))
}

.tw-bg-saphetorBlue{
  --bg-opacity: 1;
  background-color:#577396;
  background-color:rgba(87, 115, 150, var(--bg-opacity))
}

.tw-bg-pink-500{
  --bg-opacity: 1;
  background-color:#ec4899;
  background-color:rgba(236, 72, 153, var(--bg-opacity))
}

.tw-bg-sky-500{
  --bg-opacity: 1;
  background-color:#0ea5e9;
  background-color:rgba(14, 165, 233, var(--bg-opacity))
}

.tw-bg-purple-500{
  --bg-opacity: 1;
  background-color:#a855f7;
  background-color:rgba(168, 85, 247, var(--bg-opacity))
}

.tw-bg-indigo-500{
  --bg-opacity: 1;
  background-color:#6366f1;
  background-color:rgba(99, 102, 241, var(--bg-opacity))
}

.tw-bg-indigo-600{
  --bg-opacity: 1;
  background-color:#4f46e5;
  background-color:rgba(79, 70, 229, var(--bg-opacity))
}

.tw-bg-blue-300{
  --bg-opacity: 1;
  background-color:#93c5fd;
  background-color:rgba(147, 197, 253, var(--bg-opacity))
}

.tw-bg-blue-400{
  --bg-opacity: 1;
  background-color:#60a5fa;
  background-color:rgba(96, 165, 250, var(--bg-opacity))
}

.tw-bg-blue-500{
  --bg-opacity: 1;
  background-color:#3b82f6;
  background-color:rgba(59, 130, 246, var(--bg-opacity))
}

.tw-bg-cyan-500{
  --bg-opacity: 1;
  background-color:#06b6d4;
  background-color:rgba(6, 182, 212, var(--bg-opacity))
}

.tw-bg-teal-500{
  --bg-opacity: 1;
  background-color:#14b8a6;
  background-color:rgba(20, 184, 166, var(--bg-opacity))
}

.tw-bg-green-500{
  --bg-opacity: 1;
  background-color:#22c55e;
  background-color:rgba(34, 197, 94, var(--bg-opacity))
}

.tw-bg-green-700{
  --bg-opacity: 1;
  background-color:#15803d;
  background-color:rgba(21, 128, 61, var(--bg-opacity))
}

.tw-bg-yellow-100{
  --bg-opacity: 1;
  background-color:#fef9c3;
  background-color:rgba(254, 249, 195, var(--bg-opacity))
}

.tw-bg-yellow-500{
  --bg-opacity: 1;
  background-color:#eab308;
  background-color:rgba(234, 179, 8, var(--bg-opacity))
}

.tw-bg-amber-500{
  --bg-opacity: 1;
  background-color:#f59e0b;
  background-color:rgba(245, 158, 11, var(--bg-opacity))
}

.tw-bg-orange-401{
  --bg-opacity: 1;
  background-color:#ff6f23;
  background-color:rgba(255, 111, 35, var(--bg-opacity))
}

.tw-bg-orange-500{
  --bg-opacity: 1;
  background-color:#f97316;
  background-color:rgba(249, 115, 22, var(--bg-opacity))
}

.tw-bg-orange-600{
  --bg-opacity: 1;
  background-color:#ea580c;
  background-color:rgba(234, 88, 12, var(--bg-opacity))
}

.tw-bg-red-100{
  --bg-opacity: 1;
  background-color:#fee2e2;
  background-color:rgba(254, 226, 226, var(--bg-opacity))
}

.tw-bg-red-300{
  --bg-opacity: 1;
  background-color:#fca5a5;
  background-color:rgba(252, 165, 165, var(--bg-opacity))
}

.tw-bg-red-500{
  --bg-opacity: 1;
  background-color:#ef4444;
  background-color:rgba(239, 68, 68, var(--bg-opacity))
}

.tw-bg-red-600{
  --bg-opacity: 1;
  background-color:#dc2626;
  background-color:rgba(220, 38, 38, var(--bg-opacity))
}

.tw-bg-red-700{
  --bg-opacity: 1;
  background-color:#b91c1c;
  background-color:rgba(185, 28, 28, var(--bg-opacity))
}

.tw-bg-gray-100{
  --bg-opacity: 1;
  background-color:#f4f4f5;
  background-color:rgba(244, 244, 245, var(--bg-opacity))
}

.tw-bg-gray-200{
  --bg-opacity: 1;
  background-color:#e4e4e7;
  background-color:rgba(228, 228, 231, var(--bg-opacity))
}

.tw-bg-gray-300{
  --bg-opacity: 1;
  background-color:#d4d4d8;
  background-color:rgba(212, 212, 216, var(--bg-opacity))
}

.tw-bg-gray-400{
  --bg-opacity: 1;
  background-color:#a1a1aa;
  background-color:rgba(161, 161, 170, var(--bg-opacity))
}

.tw-bg-coolGray-100{
  --bg-opacity: 1;
  background-color:#f3f4f6;
  background-color:rgba(243, 244, 246, var(--bg-opacity))
}

.tw-bg-coolGray-200{
  --bg-opacity: 1;
  background-color:#e5e7eb;
  background-color:rgba(229, 231, 235, var(--bg-opacity))
}

.tw-bg-coolGray-300{
  --bg-opacity: 1;
  background-color:#d1d5db;
  background-color:rgba(209, 213, 219, var(--bg-opacity))
}

.tw-bg-coolGray-800{
  --bg-opacity: 1;
  background-color:#1f2937;
  background-color:rgba(31, 41, 55, var(--bg-opacity))
}

.tw-bg-blueGray-50{
  --bg-opacity: 1;
  background-color:#f8fafc;
  background-color:rgba(248, 250, 252, var(--bg-opacity))
}

.tw-bg-blueGray-100{
  --bg-opacity: 1;
  background-color:#f1f5f9;
  background-color:rgba(241, 245, 249, var(--bg-opacity))
}

.tw-bg-blueGray-200{
  --bg-opacity: 1;
  background-color:#e2e8f0;
  background-color:rgba(226, 232, 240, var(--bg-opacity))
}

.tw-bg-blueGray-300{
  --bg-opacity: 1;
  background-color:#cbd5e1;
  background-color:rgba(203, 213, 225, var(--bg-opacity))
}

.tw-bg-blueGray-400{
  --bg-opacity: 1;
  background-color:#94a3b8;
  background-color:rgba(148, 163, 184, var(--bg-opacity))
}

.tw-bg-blueGray-500{
  --bg-opacity: 1;
  background-color:#64748b;
  background-color:rgba(100, 116, 139, var(--bg-opacity))
}

.tw-bg-blueGray-600{
  --bg-opacity: 1;
  background-color:#475569;
  background-color:rgba(71, 85, 105, var(--bg-opacity))
}

.tw-bg-blueGray-800{
  --bg-opacity: 1;
  background-color:#1e293b;
  background-color:rgba(30, 41, 59, var(--bg-opacity))
}

.hover\\:tw-bg-green-100:hover{
  --bg-opacity: 1;
  background-color:#dcfce7;
  background-color:rgba(220, 252, 231, var(--bg-opacity))
}

.hover\\:tw-bg-green-800:hover{
  --bg-opacity: 1;
  background-color:#166534;
  background-color:rgba(22, 101, 52, var(--bg-opacity))
}

.hover\\:tw-bg-red-700:hover{
  --bg-opacity: 1;
  background-color:#b91c1c;
  background-color:rgba(185, 28, 28, var(--bg-opacity))
}

.hover\\:tw-bg-red-800:hover{
  --bg-opacity: 1;
  background-color:#991b1b;
  background-color:rgba(153, 27, 27, var(--bg-opacity))
}

.hover\\:tw-bg-blueGray-50:hover{
  --bg-opacity: 1;
  background-color:#f8fafc;
  background-color:rgba(248, 250, 252, var(--bg-opacity))
}

.hover\\:tw-bg-blueGray-100:hover{
  --bg-opacity: 1;
  background-color:#f1f5f9;
  background-color:rgba(241, 245, 249, var(--bg-opacity))
}

.hover\\:tw-bg-blueGray-200:hover{
  --bg-opacity: 1;
  background-color:#e2e8f0;
  background-color:rgba(226, 232, 240, var(--bg-opacity))
}

.focus\\:tw-bg-primary:focus{
  --bg-opacity: 1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity))
}

.tw-bg-gradient-to-t{
  background-image:linear-gradient(to top, var(--gradient-color-stops))
}

.tw-bg-gradient-to-r{
  background-image:linear-gradient(to right, var(--gradient-color-stops))
}

.tw-bg-gradient-to-b{
  background-image:linear-gradient(to bottom, var(--gradient-color-stops))
}

.tw-from-transparent{
  --gradient-from-color: rgba(255,255,255,0.001);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) 
}

.tw-to-white{
  --gradient-to-color: #fff 
}

.tw-bg-opacity-0{
  --bg-opacity: 0 
}

.tw-bg-opacity-10{
  --bg-opacity: 0.1 
}

.tw-bg-opacity-20{
  --bg-opacity: 0.2 
}

.tw-bg-opacity-30{
  --bg-opacity: 0.3 
}

.tw-bg-opacity-60{
  --bg-opacity: 0.6 
}

.tw-bg-opacity-75{
  --bg-opacity: 0.75 
}

.tw-bg-opacity-80{
  --bg-opacity: 0.8 
}

.hover\\:tw-bg-opacity-20:hover{
  --bg-opacity: 0.2 
}

.tw-border-collapse{
  border-collapse:collapse
}

.tw-border-transparent{
  border-color:rgba(255,255,255,.001)
}

.tw-border-black{
  --border-opacity: 1;
  border-color:#000;
  border-color:rgba(0, 0, 0, var(--border-opacity))
}

.tw-border-white{
  --border-opacity: 1;
  border-color:#fff;
  border-color:rgba(255, 255, 255, var(--border-opacity))
}

.tw-border-primary{
  --border-opacity: 1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.tw-border-saphetorBlue{
  --border-opacity: 1;
  border-color:#577396;
  border-color:rgba(87, 115, 150, var(--border-opacity))
}

.tw-border-tableBorder{
  --border-opacity: 1;
  border-color:#3cdbc0;
  border-color:rgba(60, 219, 192, var(--border-opacity))
}

.tw-border-yellow-300{
  --border-opacity: 1;
  border-color:#fde047;
  border-color:rgba(253, 224, 71, var(--border-opacity))
}

.tw-border-red-400{
  --border-opacity: 1;
  border-color:#f87171;
  border-color:rgba(248, 113, 113, var(--border-opacity))
}

.tw-border-red-500{
  --border-opacity: 1;
  border-color:#ef4444;
  border-color:rgba(239, 68, 68, var(--border-opacity))
}

.tw-border-red-700{
  --border-opacity: 1;
  border-color:#b91c1c;
  border-color:rgba(185, 28, 28, var(--border-opacity))
}

.tw-border-gray-100{
  --border-opacity: 1;
  border-color:#f4f4f5;
  border-color:rgba(244, 244, 245, var(--border-opacity))
}

.tw-border-gray-200{
  --border-opacity: 1;
  border-color:#e4e4e7;
  border-color:rgba(228, 228, 231, var(--border-opacity))
}

.tw-border-gray-300{
  --border-opacity: 1;
  border-color:#d4d4d8;
  border-color:rgba(212, 212, 216, var(--border-opacity))
}

.tw-border-gray-400{
  --border-opacity: 1;
  border-color:#a1a1aa;
  border-color:rgba(161, 161, 170, var(--border-opacity))
}

.tw-border-blueGray-100{
  --border-opacity: 1;
  border-color:#f1f5f9;
  border-color:rgba(241, 245, 249, var(--border-opacity))
}

.tw-border-blueGray-200{
  --border-opacity: 1;
  border-color:#e2e8f0;
  border-color:rgba(226, 232, 240, var(--border-opacity))
}

.tw-border-blueGray-300{
  --border-opacity: 1;
  border-color:#cbd5e1;
  border-color:rgba(203, 213, 225, var(--border-opacity))
}

.tw-border-blueGray-400{
  --border-opacity: 1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity))
}

.tw-border-blueGray-500{
  --border-opacity: 1;
  border-color:#64748b;
  border-color:rgba(100, 116, 139, var(--border-opacity))
}

.hover\\:tw-border-transparent:hover{
  border-color:rgba(255,255,255,.001)
}

.hover\\:tw-border-gray-400:hover{
  --border-opacity: 1;
  border-color:#a1a1aa;
  border-color:rgba(161, 161, 170, var(--border-opacity))
}

.hover\\:tw-border-blueGray-300:hover{
  --border-opacity: 1;
  border-color:#cbd5e1;
  border-color:rgba(203, 213, 225, var(--border-opacity))
}

.focus\\:tw-border-primary:focus{
  --border-opacity: 1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.focus\\:tw-border-primaryLighter:focus{
  --border-opacity: 1;
  border-color:#35c5ad;
  border-color:rgba(53, 197, 173, var(--border-opacity))
}

.focus\\:tw-border-blue-300:focus{
  --border-opacity: 1;
  border-color:#93c5fd;
  border-color:rgba(147, 197, 253, var(--border-opacity))
}

.tw-border-opacity-30{
  --border-opacity: 0.3 
}

.tw-rounded-none{
  border-radius:0px
}

.tw-rounded-sm{
  border-radius:2px
}

.tw-rounded{
  border-radius:4px
}

.tw-rounded-md{
  border-radius:6px
}

.tw-rounded-lg{
  border-radius:8px
}

.tw-rounded-3xl{
  border-radius:24px
}

.tw-rounded-full{
  border-radius:9999px
}

.tw-rounded-bl-2xl{
  border-bottom-left-radius:16px
}

.tw-border-solid{
  border-style:solid
}

.tw-border-none{
  border-style:none
}

.tw-border-0{
  border-width:0
}

.tw-border-2{
  border-width:2px
}

.tw-border{
  border-width:1px
}

.tw-border-t-0{
  border-top-width:0
}

.tw-border-b-2{
  border-bottom-width:2px
}

.tw-border-t-4{
  border-top-width:4px
}

.tw-border-l-4{
  border-left-width:4px
}

.tw-border-t{
  border-top-width:1px
}

.tw-border-r{
  border-right-width:1px
}

.tw-border-b{
  border-bottom-width:1px
}

.tw-border-l{
  border-left-width:1px
}

.tw-cursor-pointer{
  cursor:pointer
}

.tw-cursor-progress{
  cursor:progress
}

.tw-cursor-not-allowed{
  cursor:not-allowed
}

.tw-block{
  display:block
}

.tw-inline-block{
  display:inline-block
}

.tw-inline{
  display:inline
}

.tw-flex{
  display:flex
}

.tw-inline-flex{
  display:inline-flex
}

.tw-grid{
  display:grid
}

.tw-hidden{
  display:none
}

.tw-flex-row{
  flex-direction:row
}

.tw-flex-col{
  flex-direction:column
}

.tw-flex-wrap{
  flex-wrap:wrap
}

.tw-flex-wrap-reverse{
  flex-wrap:wrap-reverse
}

.tw-flex-no-wrap{
  flex-wrap:nowrap
}

.tw-items-start{
  align-items:flex-start
}

.tw-items-end{
  align-items:flex-end
}

.tw-items-center{
  align-items:center
}

.tw-items-baseline{
  align-items:baseline
}

.tw-items-stretch{
  align-items:stretch
}

.tw-content-center{
  align-content:center
}

.tw-justify-items-end{
  justify-items:end
}

.tw-justify-items-center{
  justify-items:center
}

.tw-justify-start{
  justify-content:flex-start
}

.tw-justify-end{
  justify-content:flex-end
}

.tw-justify-center{
  justify-content:center
}

.tw-justify-between{
  justify-content:space-between
}

.tw-justify-evenly{
  justify-content:space-evenly
}

.tw-flex-1{
  flex:1 1 0%
}

.tw-flex-none{
  flex:none
}

.tw-flex-content{
  flex:0 0 auto
}

.tw-flex-grow-333{
  flex-grow:333
}

.tw-flex-grow-666{
  flex-grow:666
}

.tw-flex-grow-999{
  flex-grow:999
}

.tw-flex-grow{
  flex-grow:1
}

.tw-flex-shrink-0{
  flex-shrink:0
}

.tw-flex-shrink{
  flex-shrink:1
}

.tw-float-right{
  float:right
}

.tw-float-left{
  float:left
}

.tw-font-sans{
  font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"
}

.tw-font-saphetor{
  font-family:Cabin,Helvetica Neue,Helvetica,Arial,sans-serif
}

.tw-font-hairline{
  font-weight:100
}

.tw-font-light{
  font-weight:300
}

.tw-font-normal{
  font-weight:400
}

.tw-font-medium{
  font-weight:500
}

.tw-font-semibold{
  font-weight:600
}

.tw-font-bold{
  font-weight:700
}

.tw-h-0{
  height:0px
}

.tw-h-1{
  height:4px
}

.tw-h-2{
  height:8px
}

.tw-h-3{
  height:12px
}

.tw-h-4{
  height:16px
}

.tw-h-5{
  height:20px
}

.tw-h-6{
  height:24px
}

.tw-h-7{
  height:28px
}

.tw-h-8{
  height:32px
}

.tw-h-10{
  height:40px
}

.tw-h-12{
  height:48px
}

.tw-h-14{
  height:56px
}

.tw-h-32{
  height:128px
}

.tw-h-36{
  height:144px
}

.tw-h-40{
  height:160px
}

.tw-h-auto{
  height:auto
}

.tw-h-px{
  height:1px
}

.tw-h-0\\.5{
  height:2px
}

.tw-h-full{
  height:100%
}

.tw-h-screen{
  height:100vh
}

.tw-text-3xs{
  font-size:10px;
  line-height:12px
}

.tw-text-2xs{
  font-size:11px;
  line-height:14px
}

.tw-text-xs{
  font-size:12px;
  line-height:16px
}

.tw-text-sm{
  font-size:14px;
  line-height:20px
}

.tw-text-base{
  font-size:16px;
  line-height:24px
}

.tw-text-lg{
  font-size:18px;
  line-height:28px
}

.tw-text-xl{
  font-size:20px;
  line-height:28px
}

.tw-text-2xl{
  font-size:24px;
  line-height:32px
}

.tw-text-3xl{
  font-size:30px;
  line-height:36px
}

.tw-text-4xl{
  font-size:36px;
  line-height:40px
}

.tw-leading-5{
  line-height:20px
}

.tw-leading-none{
  line-height:1
}

.tw-leading-tight{
  line-height:1.25
}

.tw-leading-relaxed{
  line-height:1.625
}

.tw-leading-loose{
  line-height:2
}

.tw-list-none{
  list-style-type:none
}

.tw-list-disc{
  list-style-type:disc
}

.tw-m-0{
  margin:0px
}

.tw-m-1{
  margin:4px
}

.tw-m-2{
  margin:8px
}

.tw-m-4{
  margin:16px
}

.tw-m-8{
  margin:32px
}

.tw-m-auto{
  margin:auto
}

.tw-m-0\\.5{
  margin:2px
}

.tw--m-2{
  margin:-8px
}

.tw-my-0{
  margin-top:0px;
  margin-bottom:0px
}

.tw-mx-0{
  margin-left:0px;
  margin-right:0px
}

.tw-my-1{
  margin-top:4px;
  margin-bottom:4px
}

.tw-mx-1{
  margin-left:4px;
  margin-right:4px
}

.tw-my-2{
  margin-top:8px;
  margin-bottom:8px
}

.tw-mx-2{
  margin-left:8px;
  margin-right:8px
}

.tw-my-3{
  margin-top:12px;
  margin-bottom:12px
}

.tw-mx-3{
  margin-left:12px;
  margin-right:12px
}

.tw-my-4{
  margin-top:16px;
  margin-bottom:16px
}

.tw-mx-4{
  margin-left:16px;
  margin-right:16px
}

.tw-my-5{
  margin-top:20px;
  margin-bottom:20px
}

.tw-my-6{
  margin-top:24px;
  margin-bottom:24px
}

.tw-mx-6{
  margin-left:24px;
  margin-right:24px
}

.tw-my-8{
  margin-top:32px;
  margin-bottom:32px
}

.tw-my-12{
  margin-top:48px;
  margin-bottom:48px
}

.tw-mx-12{
  margin-left:48px;
  margin-right:48px
}

.tw-mx-auto{
  margin-left:auto;
  margin-right:auto
}

.tw-my-px{
  margin-top:1px;
  margin-bottom:1px
}

.tw-mx-px{
  margin-left:1px;
  margin-right:1px
}

.tw-my-0\\.5{
  margin-top:2px;
  margin-bottom:2px
}

.tw-mx-0\\.5{
  margin-left:2px;
  margin-right:2px
}

.tw--mx-0{
  margin-left:0px;
  margin-right:0px
}

.tw--my-2{
  margin-top:-8px;
  margin-bottom:-8px
}

.tw--my-6{
  margin-top:-24px;
  margin-bottom:-24px
}

.tw--mx-0\\.5{
  margin-left:-2px;
  margin-right:-2px
}

.tw-mt-0{
  margin-top:0px
}

.tw-mr-0{
  margin-right:0px
}

.tw-mb-0{
  margin-bottom:0px
}

.tw-ml-0{
  margin-left:0px
}

.tw-mt-1{
  margin-top:4px
}

.tw-mr-1{
  margin-right:4px
}

.tw-mb-1{
  margin-bottom:4px
}

.tw-ml-1{
  margin-left:4px
}

.tw-mt-2{
  margin-top:8px
}

.tw-mr-2{
  margin-right:8px
}

.tw-mb-2{
  margin-bottom:8px
}

.tw-ml-2{
  margin-left:8px
}

.tw-mt-3{
  margin-top:12px
}

.tw-mr-3{
  margin-right:12px
}

.tw-mb-3{
  margin-bottom:12px
}

.tw-ml-3{
  margin-left:12px
}

.tw-mt-4{
  margin-top:16px
}

.tw-mr-4{
  margin-right:16px
}

.tw-mb-4{
  margin-bottom:16px
}

.tw-ml-4{
  margin-left:16px
}

.tw-mr-5{
  margin-right:20px
}

.tw-ml-5{
  margin-left:20px
}

.tw-mt-6{
  margin-top:24px
}

.tw-mr-6{
  margin-right:24px
}

.tw-mb-6{
  margin-bottom:24px
}

.tw-ml-6{
  margin-left:24px
}

.tw-mt-7{
  margin-top:28px
}

.tw-mt-8{
  margin-top:32px
}

.tw-mr-8{
  margin-right:32px
}

.tw-mb-8{
  margin-bottom:32px
}

.tw-ml-8{
  margin-left:32px
}

.tw-mt-10{
  margin-top:40px
}

.tw-mb-10{
  margin-bottom:40px
}

.tw-mt-12{
  margin-top:48px
}

.tw-mr-12{
  margin-right:48px
}

.tw-mb-12{
  margin-bottom:48px
}

.tw-mr-20{
  margin-right:80px
}

.tw-ml-auto{
  margin-left:auto
}

.tw-mt-px{
  margin-top:1px
}

.tw-mt-0\\.5{
  margin-top:2px
}

.tw-mr-0\\.5{
  margin-right:2px
}

.tw-mb-0\\.5{
  margin-bottom:2px
}

.tw-ml-0\\.5{
  margin-left:2px
}

.tw-mr-1\\.5{
  margin-right:6px
}

.tw-ml-1\\.5{
  margin-left:6px
}

.tw-mt-2\\.5{
  margin-top:10px
}

.tw-mb-2\\.5{
  margin-bottom:10px
}

.tw-mr-rem-1{
  margin-right:1rem
}

.tw--mt-0{
  margin-top:0px
}

.tw--mt-1{
  margin-top:-4px
}

.tw--mr-1{
  margin-right:-4px
}

.tw--mr-2{
  margin-right:-8px
}

.tw--ml-2{
  margin-left:-8px
}

.tw--mt-3{
  margin-top:-12px
}

.tw--mb-4{
  margin-bottom:-16px
}

.tw--mt-6{
  margin-top:-24px
}

.tw--mt-8{
  margin-top:-32px
}

.tw--mt-0\\.5{
  margin-top:-2px
}

.tw-max-h-40{
  max-height:160px
}

.tw-max-h-44{
  max-height:176px
}

.tw-max-h-60{
  max-height:240px
}

.tw-max-h-66{
  max-height:266px
}

.tw-max-h-80{
  max-height:320px
}

.tw-max-h-screen{
  max-height:100vh
}

.tw-max-h-3dProtMax{
  max-height:590px
}

.tw-max-w-60{
  max-width:240px
}

.tw-max-w-72{
  max-width:288px
}

.tw-max-w-80{
  max-width:320px
}

.tw-max-w-96{
  max-width:384px
}

.tw-max-w-160{
  max-width:640px
}

.tw-max-w-1800{
  max-width:1800px
}

.tw-max-w-screen-sm{
  max-width:640px
}

.tw-max-w-screen-xl{
  max-width:1280px
}

.tw-max-w-1\\/2{
  max-width:50%
}

.tw-max-w-md{
  max-width:448px
}

.tw-max-w-3xl{
  max-width:768px
}

.tw-max-w-4xl{
  max-width:896px
}

.tw-max-w-7xl{
  max-width:1280px
}

.tw-max-w-full{
  max-width:100%
}

.tw-max-w-max{
  max-width:-webkit-max-content;
  max-width:max-content
}

.tw-max-w-screen{
  max-width:100vw
}

.tw-max-w-screen90{
  max-width:90vw
}

.tw-min-h-6{
  min-height:24px
}

.tw-min-h-8{
  min-height:32px
}

.tw-min-h-16{
  min-height:64px
}

.tw-min-h-56{
  min-height:224px
}

.tw-min-h-96{
  min-height:384px
}

.tw-min-w-0{
  min-width:0
}

.tw-min-w-6{
  min-width:24px
}

.tw-min-w-16{
  min-width:64px
}

.tw-min-w-24{
  min-width:96px
}

.tw-min-w-28{
  min-width:112px
}

.tw-min-w-40{
  min-width:160px
}

.tw-min-w-52{
  min-width:208px
}

.tw-min-w-64{
  min-width:256px
}

.tw-min-w-66{
  min-width:266px
}

.tw-min-w-72{
  min-width:288px
}

.tw-min-w-80{
  min-width:320px
}

.tw-min-w-96{
  min-width:384px
}

.tw-min-w-full{
  min-width:100%
}

.tw-min-w-stackedBar{
  min-width:20px
}

.tw-object-contain{
  object-fit:contain
}

.tw-object-left{
  object-position:left
}

.tw-opacity-0{
  opacity:0
}

.tw-opacity-20{
  opacity:.2
}

.tw-opacity-25{
  opacity:.25
}

.tw-opacity-30{
  opacity:.3
}

.tw-opacity-40{
  opacity:.4
}

.tw-opacity-50{
  opacity:.5
}

.tw-opacity-60{
  opacity:.6
}

.tw-opacity-70{
  opacity:.7
}

.tw-opacity-75{
  opacity:.75
}

.tw-opacity-80{
  opacity:.8
}

.tw-opacity-90{
  opacity:.9
}

.tw-opacity-100{
  opacity:1
}

.hover\\:tw-opacity-100:hover{
  opacity:1
}

.tw-outline-none{
  outline:2px solid rgba(0,0,0,0);
  outline-offset:2px
}

.focus\\:tw-outline-none:focus{
  outline:2px solid rgba(0,0,0,0);
  outline-offset:2px
}

.tw-overflow-auto{
  overflow:auto
}

.tw-overflow-hidden{
  overflow:hidden
}

.tw-overflow-visible{
  overflow:visible
}

.tw-overflow-scroll{
  overflow:scroll
}

.tw-overflow-x-auto{
  overflow-x:auto
}

.tw-overflow-y-auto{
  overflow-y:auto
}

.tw-overflow-x-scroll{
  overflow-x:scroll
}

.tw-p-0{
  padding:0px
}

.tw-p-1{
  padding:4px
}

.tw-p-2{
  padding:8px
}

.tw-p-3{
  padding:12px
}

.tw-p-4{
  padding:16px
}

.tw-p-5{
  padding:20px
}

.tw-p-6{
  padding:24px
}

.tw-p-8{
  padding:32px
}

.tw-p-10{
  padding:40px
}

.tw-p-12{
  padding:48px
}

.tw-p-16{
  padding:64px
}

.tw-p-px{
  padding:1px
}

.tw-p-0\\.5{
  padding:2px
}

.tw-p-1\\.5{
  padding:6px
}

.tw-p-2\\.5{
  padding:10px
}

.tw-py-0{
  padding-top:0px;
  padding-bottom:0px
}

.tw-px-0{
  padding-left:0px;
  padding-right:0px
}

.tw-py-1{
  padding-top:4px;
  padding-bottom:4px
}

.tw-px-1{
  padding-left:4px;
  padding-right:4px
}

.tw-py-2{
  padding-top:8px;
  padding-bottom:8px
}

.tw-px-2{
  padding-left:8px;
  padding-right:8px
}

.tw-py-3{
  padding-top:12px;
  padding-bottom:12px
}

.tw-px-3{
  padding-left:12px;
  padding-right:12px
}

.tw-py-4{
  padding-top:16px;
  padding-bottom:16px
}

.tw-px-4{
  padding-left:16px;
  padding-right:16px
}

.tw-py-6{
  padding-top:24px;
  padding-bottom:24px
}

.tw-px-6{
  padding-left:24px;
  padding-right:24px
}

.tw-py-8{
  padding-top:32px;
  padding-bottom:32px
}

.tw-px-8{
  padding-left:32px;
  padding-right:32px
}

.tw-py-10{
  padding-top:40px;
  padding-bottom:40px
}

.tw-px-10{
  padding-left:40px;
  padding-right:40px
}

.tw-px-16{
  padding-left:64px;
  padding-right:64px
}

.tw-py-px{
  padding-top:1px;
  padding-bottom:1px
}

.tw-py-0\\.5{
  padding-top:2px;
  padding-bottom:2px
}

.tw-px-0\\.5{
  padding-left:2px;
  padding-right:2px
}

.tw-px-1\\.5{
  padding-left:6px;
  padding-right:6px
}

.tw-pt-0{
  padding-top:0px
}

.tw-pr-0{
  padding-right:0px
}

.tw-pb-0{
  padding-bottom:0px
}

.tw-pt-1{
  padding-top:4px
}

.tw-pr-1{
  padding-right:4px
}

.tw-pb-1{
  padding-bottom:4px
}

.tw-pl-1{
  padding-left:4px
}

.tw-pt-2{
  padding-top:8px
}

.tw-pr-2{
  padding-right:8px
}

.tw-pb-2{
  padding-bottom:8px
}

.tw-pl-2{
  padding-left:8px
}

.tw-pt-3{
  padding-top:12px
}

.tw-pr-3{
  padding-right:12px
}

.tw-pb-3{
  padding-bottom:12px
}

.tw-pl-3{
  padding-left:12px
}

.tw-pt-4{
  padding-top:16px
}

.tw-pr-4{
  padding-right:16px
}

.tw-pb-4{
  padding-bottom:16px
}

.tw-pl-4{
  padding-left:16px
}

.tw-pt-6{
  padding-top:24px
}

.tw-pr-6{
  padding-right:24px
}

.tw-pb-6{
  padding-bottom:24px
}

.tw-pl-6{
  padding-left:24px
}

.tw-pt-8{
  padding-top:32px
}

.tw-pb-8{
  padding-bottom:32px
}

.tw-pl-8{
  padding-left:32px
}

.tw-pt-10{
  padding-top:40px
}

.tw-pb-10{
  padding-bottom:40px
}

.tw-pr-12{
  padding-right:48px
}

.tw-pb-16{
  padding-bottom:64px
}

.tw-pt-20{
  padding-top:80px
}

.tw-pb-20{
  padding-bottom:80px
}

.tw-pr-32{
  padding-right:128px
}

.tw-pt-0\\.5{
  padding-top:2px
}

.tw-pr-0\\.5{
  padding-right:2px
}

.tw-pb-0\\.5{
  padding-bottom:2px
}

.tw-pt-2\\.5{
  padding-top:10px
}

.tw-pointer-events-none{
  pointer-events:none
}

.tw-pointer-events-auto{
  pointer-events:auto
}

.tw-fixed{
  position:fixed
}

.tw-absolute{
  position:absolute
}

.tw-relative{
  position:relative
}

.tw-sticky{
  position:-webkit-sticky;
  position:sticky
}

.tw-inset-0{
  top:0px;
  right:0px;
  bottom:0px;
  left:0px
}

.tw-inset-y-0{
  top:0px;
  bottom:0px
}

.tw-inset-x-0{
  right:0px;
  left:0px
}

.tw-top-0{
  top:0px
}

.tw-right-0{
  right:0px
}

.tw-bottom-0{
  bottom:0px
}

.tw-left-0{
  left:0px
}

.tw-top-1{
  top:4px
}

.tw-right-1{
  right:4px
}

.tw-top-2{
  top:8px
}

.tw-right-2{
  right:8px
}

.tw-top-3{
  top:12px
}

.tw-left-3{
  left:12px
}

.tw-top-4{
  top:16px
}

.tw-right-5{
  right:20px
}

.tw-top-10{
  top:40px
}

.tw-right-12{
  right:48px
}

.tw-bottom-0\\.5{
  bottom:2px
}

.tw-top-1\\.5{
  top:6px
}

.tw--top-0{
  top:0px
}

.tw--top-1{
  top:-4px
}

.tw--top-3{
  top:-12px
}

.tw--left-4{
  left:-16px
}

.tw--top-5{
  top:-20px
}

.tw--top-0\\.5{
  top:-2px
}

.tw-resize-none{
  resize:none
}

.tw-shadow-md{
  box-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06)
}

.tw-shadow-lg{
  box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05)
}

.tw-shadow-xl{
  box-shadow:0 20px 25px -5px rgba(0,0,0,.1),0 10px 10px -5px rgba(0,0,0,.04)
}

.tw-shadow-2xl{
  box-shadow:0 25px 50px -12px rgba(0,0,0,.25)
}

.tw-shadow-strong{
  box-shadow:0 20px 25px -5px rgba(0,0,0,.15),0 10px 10px -5px rgba(0,0,0,.1)
}

.tw-shadow-inner{
  box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.06)
}

.tw-fill-current{
  fill:currentColor
}

.tw-stroke-current{
  stroke:currentColor
}

.tw-stroke-0{
  stroke-width:0
}

.tw-stroke-2{
  stroke-width:2
}

.tw-table-auto{
  table-layout:auto
}

.tw-text-left{
  text-align:left
}

.tw-text-center{
  text-align:center
}

.tw-text-right{
  text-align:right
}

.tw-text-justify{
  text-align:justify
}

.tw-text-white{
  --text-opacity: 1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.tw-text-primary{
  --text-opacity: 1;
  color:#2ca591;
  color:rgba(44, 165, 145, var(--text-opacity))
}

.tw-text-saphetorBlue{
  --text-opacity: 1;
  color:#577396;
  color:rgba(87, 115, 150, var(--text-opacity))
}

.tw-text-rose-600{
  --text-opacity: 1;
  color:#e11d48;
  color:rgba(225, 29, 72, var(--text-opacity))
}

.tw-text-pink-500{
  --text-opacity: 1;
  color:#ec4899;
  color:rgba(236, 72, 153, var(--text-opacity))
}

.tw-text-pink-600{
  --text-opacity: 1;
  color:#db2777;
  color:rgba(219, 39, 119, var(--text-opacity))
}

.tw-text-sky-300{
  --text-opacity: 1;
  color:#7dd3fc;
  color:rgba(125, 211, 252, var(--text-opacity))
}

.tw-text-sky-400{
  --text-opacity: 1;
  color:#38bdf8;
  color:rgba(56, 189, 248, var(--text-opacity))
}

.tw-text-sky-500{
  --text-opacity: 1;
  color:#0ea5e9;
  color:rgba(14, 165, 233, var(--text-opacity))
}

.tw-text-sky-600{
  --text-opacity: 1;
  color:#0284c7;
  color:rgba(2, 132, 199, var(--text-opacity))
}

.tw-text-purple-500{
  --text-opacity: 1;
  color:#a855f7;
  color:rgba(168, 85, 247, var(--text-opacity))
}

.tw-text-purple-600{
  --text-opacity: 1;
  color:#9333ea;
  color:rgba(147, 51, 234, var(--text-opacity))
}

.tw-text-violet-600{
  --text-opacity: 1;
  color:#7c3aed;
  color:rgba(124, 58, 237, var(--text-opacity))
}

.tw-text-indigo-300{
  --text-opacity: 1;
  color:#a5b4fc;
  color:rgba(165, 180, 252, var(--text-opacity))
}

.tw-text-indigo-500{
  --text-opacity: 1;
  color:#6366f1;
  color:rgba(99, 102, 241, var(--text-opacity))
}

.tw-text-indigo-600{
  --text-opacity: 1;
  color:#4f46e5;
  color:rgba(79, 70, 229, var(--text-opacity))
}

.tw-text-blue-300{
  --text-opacity: 1;
  color:#93c5fd;
  color:rgba(147, 197, 253, var(--text-opacity))
}

.tw-text-blue-400{
  --text-opacity: 1;
  color:#60a5fa;
  color:rgba(96, 165, 250, var(--text-opacity))
}

.tw-text-blue-500{
  --text-opacity: 1;
  color:#3b82f6;
  color:rgba(59, 130, 246, var(--text-opacity))
}

.tw-text-blue-600{
  --text-opacity: 1;
  color:#2563eb;
  color:rgba(37, 99, 235, var(--text-opacity))
}

.tw-text-cyan-500{
  --text-opacity: 1;
  color:#06b6d4;
  color:rgba(6, 182, 212, var(--text-opacity))
}

.tw-text-cyan-600{
  --text-opacity: 1;
  color:#0891b2;
  color:rgba(8, 145, 178, var(--text-opacity))
}

.tw-text-teal-500{
  --text-opacity: 1;
  color:#14b8a6;
  color:rgba(20, 184, 166, var(--text-opacity))
}

.tw-text-teal-600{
  --text-opacity: 1;
  color:#0d9488;
  color:rgba(13, 148, 136, var(--text-opacity))
}

.tw-text-emerald-600{
  --text-opacity: 1;
  color:#059669;
  color:rgba(5, 150, 105, var(--text-opacity))
}

.tw-text-green-400{
  --text-opacity: 1;
  color:#4ade80;
  color:rgba(74, 222, 128, var(--text-opacity))
}

.tw-text-green-500{
  --text-opacity: 1;
  color:#22c55e;
  color:rgba(34, 197, 94, var(--text-opacity))
}

.tw-text-green-600{
  --text-opacity: 1;
  color:#16a34a;
  color:rgba(22, 163, 74, var(--text-opacity))
}

.tw-text-lime-600{
  --text-opacity: 1;
  color:#65a30d;
  color:rgba(101, 163, 13, var(--text-opacity))
}

.tw-text-yellow-500{
  --text-opacity: 1;
  color:#eab308;
  color:rgba(234, 179, 8, var(--text-opacity))
}

.tw-text-yellow-600{
  --text-opacity: 1;
  color:#ca8a04;
  color:rgba(202, 138, 4, var(--text-opacity))
}

.tw-text-yellow-800{
  --text-opacity: 1;
  color:#854d0e;
  color:rgba(133, 77, 14, var(--text-opacity))
}

.tw-text-amber-500{
  --text-opacity: 1;
  color:#f59e0b;
  color:rgba(245, 158, 11, var(--text-opacity))
}

.tw-text-amber-600{
  --text-opacity: 1;
  color:#d97706;
  color:rgba(217, 119, 6, var(--text-opacity))
}

.tw-text-orange-400{
  --text-opacity: 1;
  color:#fb923c;
  color:rgba(251, 146, 60, var(--text-opacity))
}

.tw-text-orange-500{
  --text-opacity: 1;
  color:#f97316;
  color:rgba(249, 115, 22, var(--text-opacity))
}

.tw-text-orange-600{
  --text-opacity: 1;
  color:#ea580c;
  color:rgba(234, 88, 12, var(--text-opacity))
}

.tw-text-red-400{
  --text-opacity: 1;
  color:#f87171;
  color:rgba(248, 113, 113, var(--text-opacity))
}

.tw-text-red-500{
  --text-opacity: 1;
  color:#ef4444;
  color:rgba(239, 68, 68, var(--text-opacity))
}

.tw-text-red-600{
  --text-opacity: 1;
  color:#dc2626;
  color:rgba(220, 38, 38, var(--text-opacity))
}

.tw-text-red-700{
  --text-opacity: 1;
  color:#b91c1c;
  color:rgba(185, 28, 28, var(--text-opacity))
}

.tw-text-gray-200{
  --text-opacity: 1;
  color:#e4e4e7;
  color:rgba(228, 228, 231, var(--text-opacity))
}

.tw-text-gray-300{
  --text-opacity: 1;
  color:#d4d4d8;
  color:rgba(212, 212, 216, var(--text-opacity))
}

.tw-text-gray-400{
  --text-opacity: 1;
  color:#a1a1aa;
  color:rgba(161, 161, 170, var(--text-opacity))
}

.tw-text-gray-500{
  --text-opacity: 1;
  color:#71717a;
  color:rgba(113, 113, 122, var(--text-opacity))
}

.tw-text-gray-600{
  --text-opacity: 1;
  color:#52525b;
  color:rgba(82, 82, 91, var(--text-opacity))
}

.tw-text-gray-900{
  --text-opacity: 1;
  color:#18181b;
  color:rgba(24, 24, 27, var(--text-opacity))
}

.tw-text-coolGray-400{
  --text-opacity: 1;
  color:#9ca3af;
  color:rgba(156, 163, 175, var(--text-opacity))
}

.tw-text-coolGray-500{
  --text-opacity: 1;
  color:#6b7280;
  color:rgba(107, 114, 128, var(--text-opacity))
}

.tw-text-coolGray-600{
  --text-opacity: 1;
  color:#4b5563;
  color:rgba(75, 85, 99, var(--text-opacity))
}

.tw-text-coolGray-800{
  --text-opacity: 1;
  color:#1f2937;
  color:rgba(31, 41, 55, var(--text-opacity))
}

.tw-text-blueGray-200{
  --text-opacity: 1;
  color:#e2e8f0;
  color:rgba(226, 232, 240, var(--text-opacity))
}

.tw-text-blueGray-400{
  --text-opacity: 1;
  color:#94a3b8;
  color:rgba(148, 163, 184, var(--text-opacity))
}

.tw-text-blueGray-500{
  --text-opacity: 1;
  color:#64748b;
  color:rgba(100, 116, 139, var(--text-opacity))
}

.tw-text-blueGray-600{
  --text-opacity: 1;
  color:#475569;
  color:rgba(71, 85, 105, var(--text-opacity))
}

.tw-text-blueGray-700{
  --text-opacity: 1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity))
}

.tw-text-blueGray-800{
  --text-opacity: 1;
  color:#1e293b;
  color:rgba(30, 41, 59, var(--text-opacity))
}

.tw-text-blueGray-900{
  --text-opacity: 1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity))
}

.hover\\:tw-text-black:hover{
  --text-opacity: 1;
  color:#000;
  color:rgba(0, 0, 0, var(--text-opacity))
}

.hover\\:tw-text-white:hover{
  --text-opacity: 1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.hover\\:tw-text-primaryLighter:hover{
  --text-opacity: 1;
  color:#35c5ad;
  color:rgba(53, 197, 173, var(--text-opacity))
}

.hover\\:tw-text-sky-500:hover{
  --text-opacity: 1;
  color:#0ea5e9;
  color:rgba(14, 165, 233, var(--text-opacity))
}

.hover\\:tw-text-blueGray-300:hover{
  --text-opacity: 1;
  color:#cbd5e1;
  color:rgba(203, 213, 225, var(--text-opacity))
}

.hover\\:tw-text-blueGray-700:hover{
  --text-opacity: 1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity))
}

.hover\\:tw-text-blueGray-900:hover{
  --text-opacity: 1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity))
}

.focus\\:tw-text-white:focus{
  --text-opacity: 1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.tw-italic{
  font-style:italic
}

.tw-not-italic{
  font-style:normal
}

.tw-uppercase{
  text-transform:uppercase
}

.tw-lowercase{
  text-transform:lowercase
}

.tw-capitalize{
  text-transform:capitalize
}

.tw-underline{
  text-decoration:underline
}

.tw-line-through{
  text-decoration:line-through
}

.tw-no-underline{
  text-decoration:none
}

.hover\\:tw-underline:hover{
  text-decoration:underline
}

.hover\\:tw-no-underline:hover{
  text-decoration:none
}

.tw-tracking-wide{
  letter-spacing:.025em
}

.tw-tracking-wider{
  letter-spacing:.05em
}

.tw-select-none{
  -webkit-user-select:none;
  user-select:none
}

.tw-align-top{
  vertical-align:top
}

.tw-align-middle{
  vertical-align:middle
}

.tw-whitespace-normal{
  white-space:normal
}

.tw-whitespace-no-wrap{
  white-space:nowrap
}

.tw-whitespace-pre{
  white-space:pre
}

.tw-whitespace-pre-wrap{
  white-space:pre-wrap
}

.tw-break-normal{
  word-wrap:normal;
  overflow-wrap:normal;
  word-break:normal
}

.tw-break-words{
  word-wrap:break-word;
  overflow-wrap:break-word
}

.tw-break-all{
  word-break:break-all
}

.tw-truncate{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}

.tw-w-0{
  width:0px
}

.tw-w-1{
  width:4px
}

.tw-w-2{
  width:8px
}

.tw-w-3{
  width:12px
}

.tw-w-4{
  width:16px
}

.tw-w-5{
  width:20px
}

.tw-w-6{
  width:24px
}

.tw-w-7{
  width:28px
}

.tw-w-8{
  width:32px
}

.tw-w-9{
  width:36px
}

.tw-w-10{
  width:40px
}

.tw-w-12{
  width:48px
}

.tw-w-14{
  width:56px
}

.tw-w-16{
  width:64px
}

.tw-w-20{
  width:80px
}

.tw-w-24{
  width:96px
}

.tw-w-28{
  width:112px
}

.tw-w-32{
  width:128px
}

.tw-w-36{
  width:144px
}

.tw-w-40{
  width:160px
}

.tw-w-44{
  width:176px
}

.tw-w-48{
  width:192px
}

.tw-w-52{
  width:208px
}

.tw-w-64{
  width:256px
}

.tw-w-72{
  width:288px
}

.tw-w-80{
  width:320px
}

.tw-w-96{
  width:384px
}

.tw-w-160{
  width:640px
}

.tw-w-auto{
  width:auto
}

.tw-w-px{
  width:1px
}

.tw-w-0\\.5{
  width:2px
}

.tw-w-1\\/2{
  width:50%
}

.tw-w-1\\/3{
  width:33.333333%
}

.tw-w-1\\/4{
  width:25%
}

.tw-w-3\\/4{
  width:75%
}

.tw-w-1\\/5{
  width:20%
}

.tw-w-2\\/5{
  width:40%
}

.tw-w-3\\/5{
  width:60%
}

.tw-w-4\\/5{
  width:80%
}

.tw-w-1\\/6{
  width:16.666667%
}

.tw-w-1\\/12{
  width:8.333333%
}

.tw-w-2\\/12{
  width:16.666667%
}

.tw-w-3\\/12{
  width:25%
}

.tw-w-4\\/12{
  width:33.333333%
}

.tw-w-6\\/12{
  width:50%
}

.tw-w-11\\/12{
  width:91.666667%
}

.tw-w-1\\/20{
  width:5%
}

.tw-w-2\\/20{
  width:10%
}

.tw-w-3\\/20{
  width:15%
}

.tw-w-8\\/20{
  width:40%
}

.tw-w-12\\/100{
  width:12%
}

.tw-w-13\\/100{
  width:13%
}

.tw-w-17\\/100{
  width:17%
}

.tw-w-21\\/100{
  width:21%
}

.tw-w-full{
  width:100%
}

.tw-w-90screen{
  width:90vw
}

.tw-z-0{
  z-index:0
}

.tw-z-10{
  z-index:10
}

.tw-z-30{
  z-index:30
}

.tw-z-40{
  z-index:40
}

.tw-z-50{
  z-index:50
}

.tw-z-9998{
  z-index:9998
}

.tw-z-10001{
  z-index:10001
}

.tw-z-10002{
  z-index:10002
}

.tw--z-10{
  z-index:-10
}

.tw-gap-1{
  grid-gap:4px;
  gap:4px
}

.tw-gap-2{
  grid-gap:8px;
  gap:8px
}

.tw-gap-3{
  grid-gap:12px;
  gap:12px
}

.tw-gap-4{
  grid-gap:16px;
  gap:16px
}

.tw-gap-5{
  grid-gap:20px;
  gap:20px
}

.tw-gap-6{
  grid-gap:24px;
  gap:24px
}

.tw-gap-x-1{
  grid-column-gap:4px;
  column-gap:4px
}

.tw-gap-x-2{
  grid-column-gap:8px;
  column-gap:8px
}

.tw-gap-x-4{
  grid-column-gap:16px;
  column-gap:16px
}

.tw-gap-x-5{
  grid-column-gap:20px;
  column-gap:20px
}

.tw-gap-y-4{
  grid-row-gap:16px;
  row-gap:16px
}

.tw-grid-cols-1{
  grid-template-columns:repeat(1, minmax(0, 1fr))
}

.tw-grid-cols-2{
  grid-template-columns:repeat(2, minmax(0, 1fr))
}

.tw-grid-cols-3{
  grid-template-columns:repeat(3, minmax(0, 1fr))
}

.tw-grid-cols-6{
  grid-template-columns:repeat(6, minmax(0, 1fr))
}

.tw-transform{
  --transform-translate-x: 0;
  --transform-translate-y: 0;
  --transform-rotate: 0;
  --transform-skew-x: 0;
  --transform-skew-y: 0;
  --transform-scale-x: 1;
  --transform-scale-y: 1;
  transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
}

.tw-origin-right{
  transform-origin:right
}

.tw-scale-50{
  --transform-scale-x: .5;
  --transform-scale-y: .5 
}

.tw-rotate-45{
  --transform-rotate: 45deg 
}

.tw-rotate-180{
  --transform-rotate: 180deg 
}

.tw--translate-x-1\\/2{
  --transform-translate-x: -50% 
}

.tw-translate-x-1\\/2{
  --transform-translate-x: 50% 
}

.tw--translate-y-full{
  --transform-translate-y: -100% 
}

.tw--translate-y-1\\/2{
  --transform-translate-y: -50% 
}

.tw-translate-y-1\\/2{
  --transform-translate-y: 50% 
}

.tw-transition-all{
  transition-property:all
}

.tw-transition-colors{
  transition-property:background-color,border-color,color,fill,stroke
}

.tw-transition-opacity{
  transition-property:opacity
}

.tw-transition-transform{
  transition-property:transform
}

.tw-ease-in-out{
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)
}

.tw-duration-100{
  transition-duration:100ms
}

.tw-duration-200{
  transition-duration:200ms
}

.tw-duration-300{
  transition-duration:300ms
}

.tw-duration-500{
  transition-duration:500ms
}

.tw-duration-1000{
  transition-duration:1000ms
}

@keyframes spin{
  to{
    transform:rotate(360deg)
  }
}

@keyframes ping{
  75%,100%{
    transform:scale(2);
    opacity:0
  }
}

@keyframes pulse{
  50%{
    opacity:.5
  }
}

@keyframes bounce{
  0%,100%{
    transform:translateY(-25%);
    animation-timing-function:cubic-bezier(0.8, 0, 1, 1)
  }

  50%{
    transform:none;
    animation-timing-function:cubic-bezier(0, 0, 0.2, 1)
  }
}

@media(min-width: 640px){
  .sm\\:tw-flex-no-wrap{
    flex-wrap:nowrap
  }

  .sm\\:tw-text-xs{
    font-size:12px;
    line-height:16px
  }

  .sm\\:tw-mr-4{
    margin-right:16px
  }

  .sm\\:tw-w-24{
    width:96px
  }

  .sm\\:tw-w-4\\/12{
    width:33.333333%
  }

  .sm\\:tw-w-6\\/12{
    width:50%
  }

  .sm\\:tw-grid-cols-2{
    grid-template-columns:repeat(2, minmax(0, 1fr))
  }
}

@media(min-width: 768px){
  .md\\:tw-text-base{
    font-size:16px;
    line-height:24px
  }

  .md\\:tw-w-64{
    width:256px
  }

  .md\\:tw-w-3xl{
    width:768px
  }

  .md\\:tw-grid-cols-2{
    grid-template-columns:repeat(2, minmax(0, 1fr))
  }
}

@media(min-width: 1024px){
  .lg\\:tw-grid-cols-2{
    grid-template-columns:repeat(2, minmax(0, 1fr))
  }
}`, "",{"version":3,"sources":["webpack://./src/tailwind/tailwind.scss"],"names":[],"mappings":"AAIA;EACE;AAAA;;AAGF;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA;;AAIJ;EACE,oBAAA;EACA,kDAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,eAAA;EACA,qBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,qBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,8CAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,mBAAA;EACA,iBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,iBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,6BAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,+BAAA;EACA;AAAA;;AAGF;EACE,+BAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,uBAAA;EACA;AAAA;;AAGF;EACE,OAAA;EACA,SAAA;EACA,UAAA;EACA;AAAA;;AAGF;EACE,OAAA;EACA;AAAA;;AAGF;EACE,SAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,iBAAA;EACA,UAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,UAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,UAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,UAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,wBAAA;EACQ;AAAA;;AAGV;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,gBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,eAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,YAAA;EACA;AAAA;;AAGF;EACE,YAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA;AAAA;;AAGF;EACE,mBAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,0BAAA;EACA,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,uBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE,kBAAA;IACA;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA;;AAIJ;EACE;IACE,0BAAA;IACA;EAAA;;EAGF;IACE,cAAA;IACA;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;;EAGF;IACE,cAAA;IACA;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;AAAA;;AAIJ;EACE;IACE,cAAA;IACA;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;AAAA","sourcesContent":["/* used to generate tailwind.css -> see package.json*/\n\n/* @tailwind base; */\n\n.tw-container {\n  width: 100%\n}\n\n@media (min-width: 640px) {\n  .tw-container {\n    max-width: 640px\n  }\n}\n\n@media (min-width: 768px) {\n  .tw-container {\n    max-width: 768px\n  }\n}\n\n@media (min-width: 1024px) {\n  .tw-container {\n    max-width: 1024px\n  }\n}\n\n@media (min-width: 1280px) {\n  .tw-container {\n    max-width: 1280px\n  }\n}\n\n@media (min-width: 1366px) {\n  .tw-container {\n    max-width: 1366px\n  }\n}\n\n.tw-space-y-4 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(16px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(16px * var(--space-y-reverse))\n}\n\n.tw-bg-transparent {\n  background-color: rgba(255,255,255,0.001)\n}\n\n.tw-bg-black {\n  --bg-opacity: 1;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity))\n}\n\n.tw-bg-white {\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity))\n}\n\n.tw-bg-primary {\n  --bg-opacity: 1;\n  background-color: #2ca591;\n  background-color: rgba(44, 165, 145, var(--bg-opacity))\n}\n\n.tw-bg-primaryLighter {\n  --bg-opacity: 1;\n  background-color: #35C5AD;\n  background-color: rgba(53, 197, 173, var(--bg-opacity))\n}\n\n.tw-bg-saphetorBlue {\n  --bg-opacity: 1;\n  background-color: #577396;\n  background-color: rgba(87, 115, 150, var(--bg-opacity))\n}\n\n.tw-bg-pink-500 {\n  --bg-opacity: 1;\n  background-color: #ec4899;\n  background-color: rgba(236, 72, 153, var(--bg-opacity))\n}\n\n.tw-bg-sky-500 {\n  --bg-opacity: 1;\n  background-color: #0ea5e9;\n  background-color: rgba(14, 165, 233, var(--bg-opacity))\n}\n\n.tw-bg-purple-500 {\n  --bg-opacity: 1;\n  background-color: #a855f7;\n  background-color: rgba(168, 85, 247, var(--bg-opacity))\n}\n\n.tw-bg-indigo-500 {\n  --bg-opacity: 1;\n  background-color: #6366f1;\n  background-color: rgba(99, 102, 241, var(--bg-opacity))\n}\n\n.tw-bg-indigo-600 {\n  --bg-opacity: 1;\n  background-color: #4f46e5;\n  background-color: rgba(79, 70, 229, var(--bg-opacity))\n}\n\n.tw-bg-blue-300 {\n  --bg-opacity: 1;\n  background-color: #93c5fd;\n  background-color: rgba(147, 197, 253, var(--bg-opacity))\n}\n\n.tw-bg-blue-400 {\n  --bg-opacity: 1;\n  background-color: #60a5fa;\n  background-color: rgba(96, 165, 250, var(--bg-opacity))\n}\n\n.tw-bg-blue-500 {\n  --bg-opacity: 1;\n  background-color: #3b82f6;\n  background-color: rgba(59, 130, 246, var(--bg-opacity))\n}\n\n.tw-bg-cyan-500 {\n  --bg-opacity: 1;\n  background-color: #06b6d4;\n  background-color: rgba(6, 182, 212, var(--bg-opacity))\n}\n\n.tw-bg-teal-500 {\n  --bg-opacity: 1;\n  background-color: #14b8a6;\n  background-color: rgba(20, 184, 166, var(--bg-opacity))\n}\n\n.tw-bg-green-500 {\n  --bg-opacity: 1;\n  background-color: #22c55e;\n  background-color: rgba(34, 197, 94, var(--bg-opacity))\n}\n\n.tw-bg-green-700 {\n  --bg-opacity: 1;\n  background-color: #15803d;\n  background-color: rgba(21, 128, 61, var(--bg-opacity))\n}\n\n.tw-bg-yellow-100 {\n  --bg-opacity: 1;\n  background-color: #fef9c3;\n  background-color: rgba(254, 249, 195, var(--bg-opacity))\n}\n\n.tw-bg-yellow-500 {\n  --bg-opacity: 1;\n  background-color: #eab308;\n  background-color: rgba(234, 179, 8, var(--bg-opacity))\n}\n\n.tw-bg-amber-500 {\n  --bg-opacity: 1;\n  background-color: #f59e0b;\n  background-color: rgba(245, 158, 11, var(--bg-opacity))\n}\n\n.tw-bg-orange-401 {\n  --bg-opacity: 1;\n  background-color: #ff6f23;\n  background-color: rgba(255, 111, 35, var(--bg-opacity))\n}\n\n.tw-bg-orange-500 {\n  --bg-opacity: 1;\n  background-color: #f97316;\n  background-color: rgba(249, 115, 22, var(--bg-opacity))\n}\n\n.tw-bg-orange-600 {\n  --bg-opacity: 1;\n  background-color: #ea580c;\n  background-color: rgba(234, 88, 12, var(--bg-opacity))\n}\n\n.tw-bg-red-100 {\n  --bg-opacity: 1;\n  background-color: #fee2e2;\n  background-color: rgba(254, 226, 226, var(--bg-opacity))\n}\n\n.tw-bg-red-300 {\n  --bg-opacity: 1;\n  background-color: #fca5a5;\n  background-color: rgba(252, 165, 165, var(--bg-opacity))\n}\n\n.tw-bg-red-500 {\n  --bg-opacity: 1;\n  background-color: #ef4444;\n  background-color: rgba(239, 68, 68, var(--bg-opacity))\n}\n\n.tw-bg-red-600 {\n  --bg-opacity: 1;\n  background-color: #dc2626;\n  background-color: rgba(220, 38, 38, var(--bg-opacity))\n}\n\n.tw-bg-red-700 {\n  --bg-opacity: 1;\n  background-color: #b91c1c;\n  background-color: rgba(185, 28, 28, var(--bg-opacity))\n}\n\n.tw-bg-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f4f4f5;\n  background-color: rgba(244, 244, 245, var(--bg-opacity))\n}\n\n.tw-bg-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e4e4e7;\n  background-color: rgba(228, 228, 231, var(--bg-opacity))\n}\n\n.tw-bg-gray-300 {\n  --bg-opacity: 1;\n  background-color: #d4d4d8;\n  background-color: rgba(212, 212, 216, var(--bg-opacity))\n}\n\n.tw-bg-gray-400 {\n  --bg-opacity: 1;\n  background-color: #a1a1aa;\n  background-color: rgba(161, 161, 170, var(--bg-opacity))\n}\n\n.tw-bg-coolGray-100 {\n  --bg-opacity: 1;\n  background-color: #f3f4f6;\n  background-color: rgba(243, 244, 246, var(--bg-opacity))\n}\n\n.tw-bg-coolGray-200 {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity))\n}\n\n.tw-bg-coolGray-300 {\n  --bg-opacity: 1;\n  background-color: #d1d5db;\n  background-color: rgba(209, 213, 219, var(--bg-opacity))\n}\n\n.tw-bg-coolGray-800 {\n  --bg-opacity: 1;\n  background-color: #1f2937;\n  background-color: rgba(31, 41, 55, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-50 {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-100 {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-200 {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-300 {\n  --bg-opacity: 1;\n  background-color: #cbd5e1;\n  background-color: rgba(203, 213, 225, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-400 {\n  --bg-opacity: 1;\n  background-color: #94a3b8;\n  background-color: rgba(148, 163, 184, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-500 {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-600 {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity))\n}\n\n.tw-bg-blueGray-800 {\n  --bg-opacity: 1;\n  background-color: #1e293b;\n  background-color: rgba(30, 41, 59, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-green-100:hover {\n  --bg-opacity: 1;\n  background-color: #dcfce7;\n  background-color: rgba(220, 252, 231, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-green-800:hover {\n  --bg-opacity: 1;\n  background-color: #166534;\n  background-color: rgba(22, 101, 52, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-red-700:hover {\n  --bg-opacity: 1;\n  background-color: #b91c1c;\n  background-color: rgba(185, 28, 28, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-red-800:hover {\n  --bg-opacity: 1;\n  background-color: #991b1b;\n  background-color: rgba(153, 27, 27, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-blueGray-50:hover {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-blueGray-100:hover {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity))\n}\n\n.hover\\:tw-bg-blueGray-200:hover {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity))\n}\n\n.focus\\:tw-bg-primary:focus {\n  --bg-opacity: 1;\n  background-color: #2ca591;\n  background-color: rgba(44, 165, 145, var(--bg-opacity))\n}\n\n.tw-bg-gradient-to-t {\n  background-image: linear-gradient(to top, var(--gradient-color-stops))\n}\n\n.tw-bg-gradient-to-r {\n  background-image: linear-gradient(to right, var(--gradient-color-stops))\n}\n\n.tw-bg-gradient-to-b {\n  background-image: linear-gradient(to bottom, var(--gradient-color-stops))\n}\n\n.tw-from-transparent {\n  --gradient-from-color: rgba(255,255,255,0.001);\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0))\n}\n\n.tw-to-white {\n  --gradient-to-color: #fff\n}\n\n.tw-bg-opacity-0 {\n  --bg-opacity: 0\n}\n\n.tw-bg-opacity-10 {\n  --bg-opacity: 0.1\n}\n\n.tw-bg-opacity-20 {\n  --bg-opacity: 0.2\n}\n\n.tw-bg-opacity-30 {\n  --bg-opacity: 0.3\n}\n\n.tw-bg-opacity-60 {\n  --bg-opacity: 0.6\n}\n\n.tw-bg-opacity-75 {\n  --bg-opacity: 0.75\n}\n\n.tw-bg-opacity-80 {\n  --bg-opacity: 0.8\n}\n\n.hover\\:tw-bg-opacity-20:hover {\n  --bg-opacity: 0.2\n}\n\n.tw-border-collapse {\n  border-collapse: collapse\n}\n\n.tw-border-transparent {\n  border-color: rgba(255,255,255,0.001)\n}\n\n.tw-border-black {\n  --border-opacity: 1;\n  border-color: #000;\n  border-color: rgba(0, 0, 0, var(--border-opacity))\n}\n\n.tw-border-white {\n  --border-opacity: 1;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, var(--border-opacity))\n}\n\n.tw-border-primary {\n  --border-opacity: 1;\n  border-color: #2ca591;\n  border-color: rgba(44, 165, 145, var(--border-opacity))\n}\n\n.tw-border-saphetorBlue {\n  --border-opacity: 1;\n  border-color: #577396;\n  border-color: rgba(87, 115, 150, var(--border-opacity))\n}\n\n.tw-border-tableBorder {\n  --border-opacity: 1;\n  border-color: #3cdbc0;\n  border-color: rgba(60, 219, 192, var(--border-opacity))\n}\n\n.tw-border-yellow-300 {\n  --border-opacity: 1;\n  border-color: #fde047;\n  border-color: rgba(253, 224, 71, var(--border-opacity))\n}\n\n.tw-border-red-400 {\n  --border-opacity: 1;\n  border-color: #f87171;\n  border-color: rgba(248, 113, 113, var(--border-opacity))\n}\n\n.tw-border-red-500 {\n  --border-opacity: 1;\n  border-color: #ef4444;\n  border-color: rgba(239, 68, 68, var(--border-opacity))\n}\n\n.tw-border-red-700 {\n  --border-opacity: 1;\n  border-color: #b91c1c;\n  border-color: rgba(185, 28, 28, var(--border-opacity))\n}\n\n.tw-border-gray-100 {\n  --border-opacity: 1;\n  border-color: #f4f4f5;\n  border-color: rgba(244, 244, 245, var(--border-opacity))\n}\n\n.tw-border-gray-200 {\n  --border-opacity: 1;\n  border-color: #e4e4e7;\n  border-color: rgba(228, 228, 231, var(--border-opacity))\n}\n\n.tw-border-gray-300 {\n  --border-opacity: 1;\n  border-color: #d4d4d8;\n  border-color: rgba(212, 212, 216, var(--border-opacity))\n}\n\n.tw-border-gray-400 {\n  --border-opacity: 1;\n  border-color: #a1a1aa;\n  border-color: rgba(161, 161, 170, var(--border-opacity))\n}\n\n.tw-border-blueGray-100 {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity))\n}\n\n.tw-border-blueGray-200 {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity))\n}\n\n.tw-border-blueGray-300 {\n  --border-opacity: 1;\n  border-color: #cbd5e1;\n  border-color: rgba(203, 213, 225, var(--border-opacity))\n}\n\n.tw-border-blueGray-400 {\n  --border-opacity: 1;\n  border-color: #94a3b8;\n  border-color: rgba(148, 163, 184, var(--border-opacity))\n}\n\n.tw-border-blueGray-500 {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity))\n}\n\n.hover\\:tw-border-transparent:hover {\n  border-color: rgba(255,255,255,0.001)\n}\n\n.hover\\:tw-border-gray-400:hover {\n  --border-opacity: 1;\n  border-color: #a1a1aa;\n  border-color: rgba(161, 161, 170, var(--border-opacity))\n}\n\n.hover\\:tw-border-blueGray-300:hover {\n  --border-opacity: 1;\n  border-color: #cbd5e1;\n  border-color: rgba(203, 213, 225, var(--border-opacity))\n}\n\n.focus\\:tw-border-primary:focus {\n  --border-opacity: 1;\n  border-color: #2ca591;\n  border-color: rgba(44, 165, 145, var(--border-opacity))\n}\n\n.focus\\:tw-border-primaryLighter:focus {\n  --border-opacity: 1;\n  border-color: #35C5AD;\n  border-color: rgba(53, 197, 173, var(--border-opacity))\n}\n\n.focus\\:tw-border-blue-300:focus {\n  --border-opacity: 1;\n  border-color: #93c5fd;\n  border-color: rgba(147, 197, 253, var(--border-opacity))\n}\n\n.tw-border-opacity-30 {\n  --border-opacity: 0.3\n}\n\n.tw-rounded-none {\n  border-radius: 0px\n}\n\n.tw-rounded-sm {\n  border-radius: 2px\n}\n\n.tw-rounded {\n  border-radius: 4px\n}\n\n.tw-rounded-md {\n  border-radius: 6px\n}\n\n.tw-rounded-lg {\n  border-radius: 8px\n}\n\n.tw-rounded-3xl {\n  border-radius: 24px\n}\n\n.tw-rounded-full {\n  border-radius: 9999px\n}\n\n.tw-rounded-bl-2xl {\n  border-bottom-left-radius: 16px\n}\n\n.tw-border-solid {\n  border-style: solid\n}\n\n.tw-border-none {\n  border-style: none\n}\n\n.tw-border-0 {\n  border-width: 0\n}\n\n.tw-border-2 {\n  border-width: 2px\n}\n\n.tw-border {\n  border-width: 1px\n}\n\n.tw-border-t-0 {\n  border-top-width: 0\n}\n\n.tw-border-b-2 {\n  border-bottom-width: 2px\n}\n\n.tw-border-t-4 {\n  border-top-width: 4px\n}\n\n.tw-border-l-4 {\n  border-left-width: 4px\n}\n\n.tw-border-t {\n  border-top-width: 1px\n}\n\n.tw-border-r {\n  border-right-width: 1px\n}\n\n.tw-border-b {\n  border-bottom-width: 1px\n}\n\n.tw-border-l {\n  border-left-width: 1px\n}\n\n.tw-cursor-pointer {\n  cursor: pointer\n}\n\n.tw-cursor-progress {\n  cursor: progress\n}\n\n.tw-cursor-not-allowed {\n  cursor: not-allowed\n}\n\n.tw-block {\n  display: block\n}\n\n.tw-inline-block {\n  display: inline-block\n}\n\n.tw-inline {\n  display: inline\n}\n\n.tw-flex {\n  display: flex\n}\n\n.tw-inline-flex {\n  display: inline-flex\n}\n\n.tw-grid {\n  display: grid\n}\n\n.tw-hidden {\n  display: none\n}\n\n.tw-flex-row {\n  flex-direction: row\n}\n\n.tw-flex-col {\n  flex-direction: column\n}\n\n.tw-flex-wrap {\n  flex-wrap: wrap\n}\n\n.tw-flex-wrap-reverse {\n  flex-wrap: wrap-reverse\n}\n\n.tw-flex-no-wrap {\n  flex-wrap: nowrap\n}\n\n.tw-items-start {\n  align-items: flex-start\n}\n\n.tw-items-end {\n  align-items: flex-end\n}\n\n.tw-items-center {\n  align-items: center\n}\n\n.tw-items-baseline {\n  align-items: baseline\n}\n\n.tw-items-stretch {\n  align-items: stretch\n}\n\n.tw-content-center {\n  align-content: center\n}\n\n.tw-justify-items-end {\n  justify-items: end\n}\n\n.tw-justify-items-center {\n  justify-items: center\n}\n\n.tw-justify-start {\n  justify-content: flex-start\n}\n\n.tw-justify-end {\n  justify-content: flex-end\n}\n\n.tw-justify-center {\n  justify-content: center\n}\n\n.tw-justify-between {\n  justify-content: space-between\n}\n\n.tw-justify-evenly {\n  justify-content: space-evenly\n}\n\n.tw-flex-1 {\n  flex: 1 1 0%\n}\n\n.tw-flex-none {\n  flex: none\n}\n\n.tw-flex-content {\n  flex: 0 0 auto\n}\n\n.tw-flex-grow-333 {\n  flex-grow: 333\n}\n\n.tw-flex-grow-666 {\n  flex-grow: 666\n}\n\n.tw-flex-grow-999 {\n  flex-grow: 999\n}\n\n.tw-flex-grow {\n  flex-grow: 1\n}\n\n.tw-flex-shrink-0 {\n  flex-shrink: 0\n}\n\n.tw-flex-shrink {\n  flex-shrink: 1\n}\n\n.tw-float-right {\n  float: right\n}\n\n.tw-float-left {\n  float: left\n}\n\n.tw-font-sans {\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"\n}\n\n.tw-font-saphetor {\n  font-family: Cabin, Helvetica Neue, Helvetica,Arial, sans-serif\n}\n\n.tw-font-hairline {\n  font-weight: 100\n}\n\n.tw-font-light {\n  font-weight: 300\n}\n\n.tw-font-normal {\n  font-weight: 400\n}\n\n.tw-font-medium {\n  font-weight: 500\n}\n\n.tw-font-semibold {\n  font-weight: 600\n}\n\n.tw-font-bold {\n  font-weight: 700\n}\n\n.tw-h-0 {\n  height: 0px\n}\n\n.tw-h-1 {\n  height: 4px\n}\n\n.tw-h-2 {\n  height: 8px\n}\n\n.tw-h-3 {\n  height: 12px\n}\n\n.tw-h-4 {\n  height: 16px\n}\n\n.tw-h-5 {\n  height: 20px\n}\n\n.tw-h-6 {\n  height: 24px\n}\n\n.tw-h-7 {\n  height: 28px\n}\n\n.tw-h-8 {\n  height: 32px\n}\n\n.tw-h-10 {\n  height: 40px\n}\n\n.tw-h-12 {\n  height: 48px\n}\n\n.tw-h-14 {\n  height: 56px\n}\n\n.tw-h-32 {\n  height: 128px\n}\n\n.tw-h-36 {\n  height: 144px\n}\n\n.tw-h-40 {\n  height: 160px\n}\n\n.tw-h-auto {\n  height: auto\n}\n\n.tw-h-px {\n  height: 1px\n}\n\n.tw-h-0\\.5 {\n  height: 2px\n}\n\n.tw-h-full {\n  height: 100%\n}\n\n.tw-h-screen {\n  height: 100vh\n}\n\n.tw-text-3xs {\n  font-size: 10px;\n  line-height: 12px\n}\n\n.tw-text-2xs {\n  font-size: 11px;\n  line-height: 14px\n}\n\n.tw-text-xs {\n  font-size: 12px;\n  line-height: 16px\n}\n\n.tw-text-sm {\n  font-size: 14px;\n  line-height: 20px\n}\n\n.tw-text-base {\n  font-size: 16px;\n  line-height: 24px\n}\n\n.tw-text-lg {\n  font-size: 18px;\n  line-height: 28px\n}\n\n.tw-text-xl {\n  font-size: 20px;\n  line-height: 28px\n}\n\n.tw-text-2xl {\n  font-size: 24px;\n  line-height: 32px\n}\n\n.tw-text-3xl {\n  font-size: 30px;\n  line-height: 36px\n}\n\n.tw-text-4xl {\n  font-size: 36px;\n  line-height: 40px\n}\n\n.tw-leading-5 {\n  line-height: 20px\n}\n\n.tw-leading-none {\n  line-height: 1\n}\n\n.tw-leading-tight {\n  line-height: 1.25\n}\n\n.tw-leading-relaxed {\n  line-height: 1.625\n}\n\n.tw-leading-loose {\n  line-height: 2\n}\n\n.tw-list-none {\n  list-style-type: none\n}\n\n.tw-list-disc {\n  list-style-type: disc\n}\n\n.tw-m-0 {\n  margin: 0px\n}\n\n.tw-m-1 {\n  margin: 4px\n}\n\n.tw-m-2 {\n  margin: 8px\n}\n\n.tw-m-4 {\n  margin: 16px\n}\n\n.tw-m-8 {\n  margin: 32px\n}\n\n.tw-m-auto {\n  margin: auto\n}\n\n.tw-m-0\\.5 {\n  margin: 2px\n}\n\n.tw--m-2 {\n  margin: -8px\n}\n\n.tw-my-0 {\n  margin-top: 0px;\n  margin-bottom: 0px\n}\n\n.tw-mx-0 {\n  margin-left: 0px;\n  margin-right: 0px\n}\n\n.tw-my-1 {\n  margin-top: 4px;\n  margin-bottom: 4px\n}\n\n.tw-mx-1 {\n  margin-left: 4px;\n  margin-right: 4px\n}\n\n.tw-my-2 {\n  margin-top: 8px;\n  margin-bottom: 8px\n}\n\n.tw-mx-2 {\n  margin-left: 8px;\n  margin-right: 8px\n}\n\n.tw-my-3 {\n  margin-top: 12px;\n  margin-bottom: 12px\n}\n\n.tw-mx-3 {\n  margin-left: 12px;\n  margin-right: 12px\n}\n\n.tw-my-4 {\n  margin-top: 16px;\n  margin-bottom: 16px\n}\n\n.tw-mx-4 {\n  margin-left: 16px;\n  margin-right: 16px\n}\n\n.tw-my-5 {\n  margin-top: 20px;\n  margin-bottom: 20px\n}\n\n.tw-my-6 {\n  margin-top: 24px;\n  margin-bottom: 24px\n}\n\n.tw-mx-6 {\n  margin-left: 24px;\n  margin-right: 24px\n}\n\n.tw-my-8 {\n  margin-top: 32px;\n  margin-bottom: 32px\n}\n\n.tw-my-12 {\n  margin-top: 48px;\n  margin-bottom: 48px\n}\n\n.tw-mx-12 {\n  margin-left: 48px;\n  margin-right: 48px\n}\n\n.tw-mx-auto {\n  margin-left: auto;\n  margin-right: auto\n}\n\n.tw-my-px {\n  margin-top: 1px;\n  margin-bottom: 1px\n}\n\n.tw-mx-px {\n  margin-left: 1px;\n  margin-right: 1px\n}\n\n.tw-my-0\\.5 {\n  margin-top: 2px;\n  margin-bottom: 2px\n}\n\n.tw-mx-0\\.5 {\n  margin-left: 2px;\n  margin-right: 2px\n}\n\n.tw--mx-0 {\n  margin-left: 0px;\n  margin-right: 0px\n}\n\n.tw--my-2 {\n  margin-top: -8px;\n  margin-bottom: -8px\n}\n\n.tw--my-6 {\n  margin-top: -24px;\n  margin-bottom: -24px\n}\n\n.tw--mx-0\\.5 {\n  margin-left: -2px;\n  margin-right: -2px\n}\n\n.tw-mt-0 {\n  margin-top: 0px\n}\n\n.tw-mr-0 {\n  margin-right: 0px\n}\n\n.tw-mb-0 {\n  margin-bottom: 0px\n}\n\n.tw-ml-0 {\n  margin-left: 0px\n}\n\n.tw-mt-1 {\n  margin-top: 4px\n}\n\n.tw-mr-1 {\n  margin-right: 4px\n}\n\n.tw-mb-1 {\n  margin-bottom: 4px\n}\n\n.tw-ml-1 {\n  margin-left: 4px\n}\n\n.tw-mt-2 {\n  margin-top: 8px\n}\n\n.tw-mr-2 {\n  margin-right: 8px\n}\n\n.tw-mb-2 {\n  margin-bottom: 8px\n}\n\n.tw-ml-2 {\n  margin-left: 8px\n}\n\n.tw-mt-3 {\n  margin-top: 12px\n}\n\n.tw-mr-3 {\n  margin-right: 12px\n}\n\n.tw-mb-3 {\n  margin-bottom: 12px\n}\n\n.tw-ml-3 {\n  margin-left: 12px\n}\n\n.tw-mt-4 {\n  margin-top: 16px\n}\n\n.tw-mr-4 {\n  margin-right: 16px\n}\n\n.tw-mb-4 {\n  margin-bottom: 16px\n}\n\n.tw-ml-4 {\n  margin-left: 16px\n}\n\n.tw-mr-5 {\n  margin-right: 20px\n}\n\n.tw-ml-5 {\n  margin-left: 20px\n}\n\n.tw-mt-6 {\n  margin-top: 24px\n}\n\n.tw-mr-6 {\n  margin-right: 24px\n}\n\n.tw-mb-6 {\n  margin-bottom: 24px\n}\n\n.tw-ml-6 {\n  margin-left: 24px\n}\n\n.tw-mt-7 {\n  margin-top: 28px\n}\n\n.tw-mt-8 {\n  margin-top: 32px\n}\n\n.tw-mr-8 {\n  margin-right: 32px\n}\n\n.tw-mb-8 {\n  margin-bottom: 32px\n}\n\n.tw-ml-8 {\n  margin-left: 32px\n}\n\n.tw-mt-10 {\n  margin-top: 40px\n}\n\n.tw-mb-10 {\n  margin-bottom: 40px\n}\n\n.tw-mt-12 {\n  margin-top: 48px\n}\n\n.tw-mr-12 {\n  margin-right: 48px\n}\n\n.tw-mb-12 {\n  margin-bottom: 48px\n}\n\n.tw-mr-20 {\n  margin-right: 80px\n}\n\n.tw-ml-auto {\n  margin-left: auto\n}\n\n.tw-mt-px {\n  margin-top: 1px\n}\n\n.tw-mt-0\\.5 {\n  margin-top: 2px\n}\n\n.tw-mr-0\\.5 {\n  margin-right: 2px\n}\n\n.tw-mb-0\\.5 {\n  margin-bottom: 2px\n}\n\n.tw-ml-0\\.5 {\n  margin-left: 2px\n}\n\n.tw-mr-1\\.5 {\n  margin-right: 6px\n}\n\n.tw-ml-1\\.5 {\n  margin-left: 6px\n}\n\n.tw-mt-2\\.5 {\n  margin-top: 10px\n}\n\n.tw-mb-2\\.5 {\n  margin-bottom: 10px\n}\n\n.tw-mr-rem-1 {\n  margin-right: 1rem\n}\n\n.tw--mt-0 {\n  margin-top: 0px\n}\n\n.tw--mt-1 {\n  margin-top: -4px\n}\n\n.tw--mr-1 {\n  margin-right: -4px\n}\n\n.tw--mr-2 {\n  margin-right: -8px\n}\n\n.tw--ml-2 {\n  margin-left: -8px\n}\n\n.tw--mt-3 {\n  margin-top: -12px\n}\n\n.tw--mb-4 {\n  margin-bottom: -16px\n}\n\n.tw--mt-6 {\n  margin-top: -24px\n}\n\n.tw--mt-8 {\n  margin-top: -32px\n}\n\n.tw--mt-0\\.5 {\n  margin-top: -2px\n}\n\n.tw-max-h-40 {\n  max-height: 160px\n}\n\n.tw-max-h-44 {\n  max-height: 176px\n}\n\n.tw-max-h-60 {\n  max-height: 240px\n}\n\n.tw-max-h-66 {\n  max-height: 266px\n}\n\n.tw-max-h-80 {\n  max-height: 320px\n}\n\n.tw-max-h-screen {\n  max-height: 100vh\n}\n\n.tw-max-h-3dProtMax {\n  max-height: 590px\n}\n\n.tw-max-w-60 {\n  max-width: 240px\n}\n\n.tw-max-w-72 {\n  max-width: 288px\n}\n\n.tw-max-w-80 {\n  max-width: 320px\n}\n\n.tw-max-w-96 {\n  max-width: 384px\n}\n\n.tw-max-w-160 {\n  max-width: 640px\n}\n\n.tw-max-w-1800 {\n  max-width: 1800px\n}\n\n.tw-max-w-screen-sm {\n  max-width: 640px\n}\n\n.tw-max-w-screen-xl {\n  max-width: 1280px\n}\n\n.tw-max-w-1\\/2 {\n  max-width: 50%\n}\n\n.tw-max-w-md {\n  max-width: 448px\n}\n\n.tw-max-w-3xl {\n  max-width: 768px\n}\n\n.tw-max-w-4xl {\n  max-width: 896px\n}\n\n.tw-max-w-7xl {\n  max-width: 1280px\n}\n\n.tw-max-w-full {\n  max-width: 100%\n}\n\n.tw-max-w-max {\n  max-width: -webkit-max-content;\n  max-width: max-content\n}\n\n.tw-max-w-screen {\n  max-width: 100vw\n}\n\n.tw-max-w-screen90 {\n  max-width: 90vw\n}\n\n.tw-min-h-6 {\n  min-height: 24px\n}\n\n.tw-min-h-8 {\n  min-height: 32px\n}\n\n.tw-min-h-16 {\n  min-height: 64px\n}\n\n.tw-min-h-56 {\n  min-height: 224px\n}\n\n.tw-min-h-96 {\n  min-height: 384px\n}\n\n.tw-min-w-0 {\n  min-width: 0\n}\n\n.tw-min-w-6 {\n  min-width: 24px\n}\n\n.tw-min-w-16 {\n  min-width: 64px\n}\n\n.tw-min-w-24 {\n  min-width: 96px\n}\n\n.tw-min-w-28 {\n  min-width: 112px\n}\n\n.tw-min-w-40 {\n  min-width: 160px\n}\n\n.tw-min-w-52 {\n  min-width: 208px\n}\n\n.tw-min-w-64 {\n  min-width: 256px\n}\n\n.tw-min-w-66 {\n  min-width: 266px\n}\n\n.tw-min-w-72 {\n  min-width: 288px\n}\n\n.tw-min-w-80 {\n  min-width: 320px\n}\n\n.tw-min-w-96 {\n  min-width: 384px\n}\n\n.tw-min-w-full {\n  min-width: 100%\n}\n\n.tw-min-w-stackedBar {\n  min-width: 20px\n}\n\n.tw-object-contain {\n  object-fit: contain\n}\n\n.tw-object-left {\n  object-position: left\n}\n\n.tw-opacity-0 {\n  opacity: 0\n}\n\n.tw-opacity-20 {\n  opacity: 0.2\n}\n\n.tw-opacity-25 {\n  opacity: 0.25\n}\n\n.tw-opacity-30 {\n  opacity: 0.3\n}\n\n.tw-opacity-40 {\n  opacity: 0.4\n}\n\n.tw-opacity-50 {\n  opacity: 0.5\n}\n\n.tw-opacity-60 {\n  opacity: 0.6\n}\n\n.tw-opacity-70 {\n  opacity: 0.7\n}\n\n.tw-opacity-75 {\n  opacity: 0.75\n}\n\n.tw-opacity-80 {\n  opacity: 0.8\n}\n\n.tw-opacity-90 {\n  opacity: 0.9\n}\n\n.tw-opacity-100 {\n  opacity: 1\n}\n\n.hover\\:tw-opacity-100:hover {\n  opacity: 1\n}\n\n.tw-outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px\n}\n\n.focus\\:tw-outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px\n}\n\n.tw-overflow-auto {\n  overflow: auto\n}\n\n.tw-overflow-hidden {\n  overflow: hidden\n}\n\n.tw-overflow-visible {\n  overflow: visible\n}\n\n.tw-overflow-scroll {\n  overflow: scroll\n}\n\n.tw-overflow-x-auto {\n  overflow-x: auto\n}\n\n.tw-overflow-y-auto {\n  overflow-y: auto\n}\n\n.tw-overflow-x-scroll {\n  overflow-x: scroll\n}\n\n.tw-p-0 {\n  padding: 0px\n}\n\n.tw-p-1 {\n  padding: 4px\n}\n\n.tw-p-2 {\n  padding: 8px\n}\n\n.tw-p-3 {\n  padding: 12px\n}\n\n.tw-p-4 {\n  padding: 16px\n}\n\n.tw-p-5 {\n  padding: 20px\n}\n\n.tw-p-6 {\n  padding: 24px\n}\n\n.tw-p-8 {\n  padding: 32px\n}\n\n.tw-p-10 {\n  padding: 40px\n}\n\n.tw-p-12 {\n  padding: 48px\n}\n\n.tw-p-16 {\n  padding: 64px\n}\n\n.tw-p-px {\n  padding: 1px\n}\n\n.tw-p-0\\.5 {\n  padding: 2px\n}\n\n.tw-p-1\\.5 {\n  padding: 6px\n}\n\n.tw-p-2\\.5 {\n  padding: 10px\n}\n\n.tw-py-0 {\n  padding-top: 0px;\n  padding-bottom: 0px\n}\n\n.tw-px-0 {\n  padding-left: 0px;\n  padding-right: 0px\n}\n\n.tw-py-1 {\n  padding-top: 4px;\n  padding-bottom: 4px\n}\n\n.tw-px-1 {\n  padding-left: 4px;\n  padding-right: 4px\n}\n\n.tw-py-2 {\n  padding-top: 8px;\n  padding-bottom: 8px\n}\n\n.tw-px-2 {\n  padding-left: 8px;\n  padding-right: 8px\n}\n\n.tw-py-3 {\n  padding-top: 12px;\n  padding-bottom: 12px\n}\n\n.tw-px-3 {\n  padding-left: 12px;\n  padding-right: 12px\n}\n\n.tw-py-4 {\n  padding-top: 16px;\n  padding-bottom: 16px\n}\n\n.tw-px-4 {\n  padding-left: 16px;\n  padding-right: 16px\n}\n\n.tw-py-6 {\n  padding-top: 24px;\n  padding-bottom: 24px\n}\n\n.tw-px-6 {\n  padding-left: 24px;\n  padding-right: 24px\n}\n\n.tw-py-8 {\n  padding-top: 32px;\n  padding-bottom: 32px\n}\n\n.tw-px-8 {\n  padding-left: 32px;\n  padding-right: 32px\n}\n\n.tw-py-10 {\n  padding-top: 40px;\n  padding-bottom: 40px\n}\n\n.tw-px-10 {\n  padding-left: 40px;\n  padding-right: 40px\n}\n\n.tw-px-16 {\n  padding-left: 64px;\n  padding-right: 64px\n}\n\n.tw-py-px {\n  padding-top: 1px;\n  padding-bottom: 1px\n}\n\n.tw-py-0\\.5 {\n  padding-top: 2px;\n  padding-bottom: 2px\n}\n\n.tw-px-0\\.5 {\n  padding-left: 2px;\n  padding-right: 2px\n}\n\n.tw-px-1\\.5 {\n  padding-left: 6px;\n  padding-right: 6px\n}\n\n.tw-pt-0 {\n  padding-top: 0px\n}\n\n.tw-pr-0 {\n  padding-right: 0px\n}\n\n.tw-pb-0 {\n  padding-bottom: 0px\n}\n\n.tw-pt-1 {\n  padding-top: 4px\n}\n\n.tw-pr-1 {\n  padding-right: 4px\n}\n\n.tw-pb-1 {\n  padding-bottom: 4px\n}\n\n.tw-pl-1 {\n  padding-left: 4px\n}\n\n.tw-pt-2 {\n  padding-top: 8px\n}\n\n.tw-pr-2 {\n  padding-right: 8px\n}\n\n.tw-pb-2 {\n  padding-bottom: 8px\n}\n\n.tw-pl-2 {\n  padding-left: 8px\n}\n\n.tw-pt-3 {\n  padding-top: 12px\n}\n\n.tw-pr-3 {\n  padding-right: 12px\n}\n\n.tw-pb-3 {\n  padding-bottom: 12px\n}\n\n.tw-pl-3 {\n  padding-left: 12px\n}\n\n.tw-pt-4 {\n  padding-top: 16px\n}\n\n.tw-pr-4 {\n  padding-right: 16px\n}\n\n.tw-pb-4 {\n  padding-bottom: 16px\n}\n\n.tw-pl-4 {\n  padding-left: 16px\n}\n\n.tw-pt-6 {\n  padding-top: 24px\n}\n\n.tw-pr-6 {\n  padding-right: 24px\n}\n\n.tw-pb-6 {\n  padding-bottom: 24px\n}\n\n.tw-pl-6 {\n  padding-left: 24px\n}\n\n.tw-pt-8 {\n  padding-top: 32px\n}\n\n.tw-pb-8 {\n  padding-bottom: 32px\n}\n\n.tw-pl-8 {\n  padding-left: 32px\n}\n\n.tw-pt-10 {\n  padding-top: 40px\n}\n\n.tw-pb-10 {\n  padding-bottom: 40px\n}\n\n.tw-pr-12 {\n  padding-right: 48px\n}\n\n.tw-pb-16 {\n  padding-bottom: 64px\n}\n\n.tw-pt-20 {\n  padding-top: 80px\n}\n\n.tw-pb-20 {\n  padding-bottom: 80px\n}\n\n.tw-pr-32 {\n  padding-right: 128px\n}\n\n.tw-pt-0\\.5 {\n  padding-top: 2px\n}\n\n.tw-pr-0\\.5 {\n  padding-right: 2px\n}\n\n.tw-pb-0\\.5 {\n  padding-bottom: 2px\n}\n\n.tw-pt-2\\.5 {\n  padding-top: 10px\n}\n\n.tw-pointer-events-none {\n  pointer-events: none\n}\n\n.tw-pointer-events-auto {\n  pointer-events: auto\n}\n\n.tw-fixed {\n  position: fixed\n}\n\n.tw-absolute {\n  position: absolute\n}\n\n.tw-relative {\n  position: relative\n}\n\n.tw-sticky {\n  position: -webkit-sticky;\n  position: sticky\n}\n\n.tw-inset-0 {\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px\n}\n\n.tw-inset-y-0 {\n  top: 0px;\n  bottom: 0px\n}\n\n.tw-inset-x-0 {\n  right: 0px;\n  left: 0px\n}\n\n.tw-top-0 {\n  top: 0px\n}\n\n.tw-right-0 {\n  right: 0px\n}\n\n.tw-bottom-0 {\n  bottom: 0px\n}\n\n.tw-left-0 {\n  left: 0px\n}\n\n.tw-top-1 {\n  top: 4px\n}\n\n.tw-right-1 {\n  right: 4px\n}\n\n.tw-top-2 {\n  top: 8px\n}\n\n.tw-right-2 {\n  right: 8px\n}\n\n.tw-top-3 {\n  top: 12px\n}\n\n.tw-left-3 {\n  left: 12px\n}\n\n.tw-top-4 {\n  top: 16px\n}\n\n.tw-right-5 {\n  right: 20px\n}\n\n.tw-top-10 {\n  top: 40px\n}\n\n.tw-right-12 {\n  right: 48px\n}\n\n.tw-bottom-0\\.5 {\n  bottom: 2px\n}\n\n.tw-top-1\\.5 {\n  top: 6px\n}\n\n.tw--top-0 {\n  top: 0px\n}\n\n.tw--top-1 {\n  top: -4px\n}\n\n.tw--top-3 {\n  top: -12px\n}\n\n.tw--left-4 {\n  left: -16px\n}\n\n.tw--top-5 {\n  top: -20px\n}\n\n.tw--top-0\\.5 {\n  top: -2px\n}\n\n.tw-resize-none {\n  resize: none\n}\n\n.tw-shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)\n}\n\n.tw-shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)\n}\n\n.tw-shadow-xl {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)\n}\n\n.tw-shadow-2xl {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25)\n}\n\n.tw-shadow-strong {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.1)\n}\n\n.tw-shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)\n}\n\n.tw-fill-current {\n  fill: currentColor\n}\n\n.tw-stroke-current {\n  stroke: currentColor\n}\n\n.tw-stroke-0 {\n  stroke-width: 0\n}\n\n.tw-stroke-2 {\n  stroke-width: 2\n}\n\n.tw-table-auto {\n  table-layout: auto\n}\n\n.tw-text-left {\n  text-align: left\n}\n\n.tw-text-center {\n  text-align: center\n}\n\n.tw-text-right {\n  text-align: right\n}\n\n.tw-text-justify {\n  text-align: justify\n}\n\n.tw-text-white {\n  --text-opacity: 1;\n  color: #fff;\n  color: rgba(255, 255, 255, var(--text-opacity))\n}\n\n.tw-text-primary {\n  --text-opacity: 1;\n  color: #2ca591;\n  color: rgba(44, 165, 145, var(--text-opacity))\n}\n\n.tw-text-saphetorBlue {\n  --text-opacity: 1;\n  color: #577396;\n  color: rgba(87, 115, 150, var(--text-opacity))\n}\n\n.tw-text-rose-600 {\n  --text-opacity: 1;\n  color: #e11d48;\n  color: rgba(225, 29, 72, var(--text-opacity))\n}\n\n.tw-text-pink-500 {\n  --text-opacity: 1;\n  color: #ec4899;\n  color: rgba(236, 72, 153, var(--text-opacity))\n}\n\n.tw-text-pink-600 {\n  --text-opacity: 1;\n  color: #db2777;\n  color: rgba(219, 39, 119, var(--text-opacity))\n}\n\n.tw-text-sky-300 {\n  --text-opacity: 1;\n  color: #7dd3fc;\n  color: rgba(125, 211, 252, var(--text-opacity))\n}\n\n.tw-text-sky-400 {\n  --text-opacity: 1;\n  color: #38bdf8;\n  color: rgba(56, 189, 248, var(--text-opacity))\n}\n\n.tw-text-sky-500 {\n  --text-opacity: 1;\n  color: #0ea5e9;\n  color: rgba(14, 165, 233, var(--text-opacity))\n}\n\n.tw-text-sky-600 {\n  --text-opacity: 1;\n  color: #0284c7;\n  color: rgba(2, 132, 199, var(--text-opacity))\n}\n\n.tw-text-purple-500 {\n  --text-opacity: 1;\n  color: #a855f7;\n  color: rgba(168, 85, 247, var(--text-opacity))\n}\n\n.tw-text-purple-600 {\n  --text-opacity: 1;\n  color: #9333ea;\n  color: rgba(147, 51, 234, var(--text-opacity))\n}\n\n.tw-text-violet-600 {\n  --text-opacity: 1;\n  color: #7c3aed;\n  color: rgba(124, 58, 237, var(--text-opacity))\n}\n\n.tw-text-indigo-300 {\n  --text-opacity: 1;\n  color: #a5b4fc;\n  color: rgba(165, 180, 252, var(--text-opacity))\n}\n\n.tw-text-indigo-500 {\n  --text-opacity: 1;\n  color: #6366f1;\n  color: rgba(99, 102, 241, var(--text-opacity))\n}\n\n.tw-text-indigo-600 {\n  --text-opacity: 1;\n  color: #4f46e5;\n  color: rgba(79, 70, 229, var(--text-opacity))\n}\n\n.tw-text-blue-300 {\n  --text-opacity: 1;\n  color: #93c5fd;\n  color: rgba(147, 197, 253, var(--text-opacity))\n}\n\n.tw-text-blue-400 {\n  --text-opacity: 1;\n  color: #60a5fa;\n  color: rgba(96, 165, 250, var(--text-opacity))\n}\n\n.tw-text-blue-500 {\n  --text-opacity: 1;\n  color: #3b82f6;\n  color: rgba(59, 130, 246, var(--text-opacity))\n}\n\n.tw-text-blue-600 {\n  --text-opacity: 1;\n  color: #2563eb;\n  color: rgba(37, 99, 235, var(--text-opacity))\n}\n\n.tw-text-cyan-500 {\n  --text-opacity: 1;\n  color: #06b6d4;\n  color: rgba(6, 182, 212, var(--text-opacity))\n}\n\n.tw-text-cyan-600 {\n  --text-opacity: 1;\n  color: #0891b2;\n  color: rgba(8, 145, 178, var(--text-opacity))\n}\n\n.tw-text-teal-500 {\n  --text-opacity: 1;\n  color: #14b8a6;\n  color: rgba(20, 184, 166, var(--text-opacity))\n}\n\n.tw-text-teal-600 {\n  --text-opacity: 1;\n  color: #0d9488;\n  color: rgba(13, 148, 136, var(--text-opacity))\n}\n\n.tw-text-emerald-600 {\n  --text-opacity: 1;\n  color: #059669;\n  color: rgba(5, 150, 105, var(--text-opacity))\n}\n\n.tw-text-green-400 {\n  --text-opacity: 1;\n  color: #4ade80;\n  color: rgba(74, 222, 128, var(--text-opacity))\n}\n\n.tw-text-green-500 {\n  --text-opacity: 1;\n  color: #22c55e;\n  color: rgba(34, 197, 94, var(--text-opacity))\n}\n\n.tw-text-green-600 {\n  --text-opacity: 1;\n  color: #16a34a;\n  color: rgba(22, 163, 74, var(--text-opacity))\n}\n\n.tw-text-lime-600 {\n  --text-opacity: 1;\n  color: #65a30d;\n  color: rgba(101, 163, 13, var(--text-opacity))\n}\n\n.tw-text-yellow-500 {\n  --text-opacity: 1;\n  color: #eab308;\n  color: rgba(234, 179, 8, var(--text-opacity))\n}\n\n.tw-text-yellow-600 {\n  --text-opacity: 1;\n  color: #ca8a04;\n  color: rgba(202, 138, 4, var(--text-opacity))\n}\n\n.tw-text-yellow-800 {\n  --text-opacity: 1;\n  color: #854d0e;\n  color: rgba(133, 77, 14, var(--text-opacity))\n}\n\n.tw-text-amber-500 {\n  --text-opacity: 1;\n  color: #f59e0b;\n  color: rgba(245, 158, 11, var(--text-opacity))\n}\n\n.tw-text-amber-600 {\n  --text-opacity: 1;\n  color: #d97706;\n  color: rgba(217, 119, 6, var(--text-opacity))\n}\n\n.tw-text-orange-400 {\n  --text-opacity: 1;\n  color: #fb923c;\n  color: rgba(251, 146, 60, var(--text-opacity))\n}\n\n.tw-text-orange-500 {\n  --text-opacity: 1;\n  color: #f97316;\n  color: rgba(249, 115, 22, var(--text-opacity))\n}\n\n.tw-text-orange-600 {\n  --text-opacity: 1;\n  color: #ea580c;\n  color: rgba(234, 88, 12, var(--text-opacity))\n}\n\n.tw-text-red-400 {\n  --text-opacity: 1;\n  color: #f87171;\n  color: rgba(248, 113, 113, var(--text-opacity))\n}\n\n.tw-text-red-500 {\n  --text-opacity: 1;\n  color: #ef4444;\n  color: rgba(239, 68, 68, var(--text-opacity))\n}\n\n.tw-text-red-600 {\n  --text-opacity: 1;\n  color: #dc2626;\n  color: rgba(220, 38, 38, var(--text-opacity))\n}\n\n.tw-text-red-700 {\n  --text-opacity: 1;\n  color: #b91c1c;\n  color: rgba(185, 28, 28, var(--text-opacity))\n}\n\n.tw-text-gray-200 {\n  --text-opacity: 1;\n  color: #e4e4e7;\n  color: rgba(228, 228, 231, var(--text-opacity))\n}\n\n.tw-text-gray-300 {\n  --text-opacity: 1;\n  color: #d4d4d8;\n  color: rgba(212, 212, 216, var(--text-opacity))\n}\n\n.tw-text-gray-400 {\n  --text-opacity: 1;\n  color: #a1a1aa;\n  color: rgba(161, 161, 170, var(--text-opacity))\n}\n\n.tw-text-gray-500 {\n  --text-opacity: 1;\n  color: #71717a;\n  color: rgba(113, 113, 122, var(--text-opacity))\n}\n\n.tw-text-gray-600 {\n  --text-opacity: 1;\n  color: #52525b;\n  color: rgba(82, 82, 91, var(--text-opacity))\n}\n\n.tw-text-gray-900 {\n  --text-opacity: 1;\n  color: #18181b;\n  color: rgba(24, 24, 27, var(--text-opacity))\n}\n\n.tw-text-coolGray-400 {\n  --text-opacity: 1;\n  color: #9ca3af;\n  color: rgba(156, 163, 175, var(--text-opacity))\n}\n\n.tw-text-coolGray-500 {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity))\n}\n\n.tw-text-coolGray-600 {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity))\n}\n\n.tw-text-coolGray-800 {\n  --text-opacity: 1;\n  color: #1f2937;\n  color: rgba(31, 41, 55, var(--text-opacity))\n}\n\n.tw-text-blueGray-200 {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity))\n}\n\n.tw-text-blueGray-400 {\n  --text-opacity: 1;\n  color: #94a3b8;\n  color: rgba(148, 163, 184, var(--text-opacity))\n}\n\n.tw-text-blueGray-500 {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity))\n}\n\n.tw-text-blueGray-600 {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity))\n}\n\n.tw-text-blueGray-700 {\n  --text-opacity: 1;\n  color: #334155;\n  color: rgba(51, 65, 85, var(--text-opacity))\n}\n\n.tw-text-blueGray-800 {\n  --text-opacity: 1;\n  color: #1e293b;\n  color: rgba(30, 41, 59, var(--text-opacity))\n}\n\n.tw-text-blueGray-900 {\n  --text-opacity: 1;\n  color: #0f172a;\n  color: rgba(15, 23, 42, var(--text-opacity))\n}\n\n.hover\\:tw-text-black:hover {\n  --text-opacity: 1;\n  color: #000;\n  color: rgba(0, 0, 0, var(--text-opacity))\n}\n\n.hover\\:tw-text-white:hover {\n  --text-opacity: 1;\n  color: #fff;\n  color: rgba(255, 255, 255, var(--text-opacity))\n}\n\n.hover\\:tw-text-primaryLighter:hover {\n  --text-opacity: 1;\n  color: #35C5AD;\n  color: rgba(53, 197, 173, var(--text-opacity))\n}\n\n.hover\\:tw-text-sky-500:hover {\n  --text-opacity: 1;\n  color: #0ea5e9;\n  color: rgba(14, 165, 233, var(--text-opacity))\n}\n\n.hover\\:tw-text-blueGray-300:hover {\n  --text-opacity: 1;\n  color: #cbd5e1;\n  color: rgba(203, 213, 225, var(--text-opacity))\n}\n\n.hover\\:tw-text-blueGray-700:hover {\n  --text-opacity: 1;\n  color: #334155;\n  color: rgba(51, 65, 85, var(--text-opacity))\n}\n\n.hover\\:tw-text-blueGray-900:hover {\n  --text-opacity: 1;\n  color: #0f172a;\n  color: rgba(15, 23, 42, var(--text-opacity))\n}\n\n.focus\\:tw-text-white:focus {\n  --text-opacity: 1;\n  color: #fff;\n  color: rgba(255, 255, 255, var(--text-opacity))\n}\n\n.tw-italic {\n  font-style: italic\n}\n\n.tw-not-italic {\n  font-style: normal\n}\n\n.tw-uppercase {\n  text-transform: uppercase\n}\n\n.tw-lowercase {\n  text-transform: lowercase\n}\n\n.tw-capitalize {\n  text-transform: capitalize\n}\n\n.tw-underline {\n  text-decoration: underline\n}\n\n.tw-line-through {\n  text-decoration: line-through\n}\n\n.tw-no-underline {\n  text-decoration: none\n}\n\n.hover\\:tw-underline:hover {\n  text-decoration: underline\n}\n\n.hover\\:tw-no-underline:hover {\n  text-decoration: none\n}\n\n.tw-tracking-wide {\n  letter-spacing: 0.025em\n}\n\n.tw-tracking-wider {\n  letter-spacing: 0.05em\n}\n\n.tw-select-none {\n  -webkit-user-select: none;\n          user-select: none\n}\n\n.tw-align-top {\n  vertical-align: top\n}\n\n.tw-align-middle {\n  vertical-align: middle\n}\n\n.tw-whitespace-normal {\n  white-space: normal\n}\n\n.tw-whitespace-no-wrap {\n  white-space: nowrap\n}\n\n.tw-whitespace-pre {\n  white-space: pre\n}\n\n.tw-whitespace-pre-wrap {\n  white-space: pre-wrap\n}\n\n.tw-break-normal {\n  word-wrap: normal;\n  overflow-wrap: normal;\n  word-break: normal\n}\n\n.tw-break-words {\n  word-wrap: break-word;\n  overflow-wrap: break-word\n}\n\n.tw-break-all {\n  word-break: break-all\n}\n\n.tw-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.tw-w-0 {\n  width: 0px\n}\n\n.tw-w-1 {\n  width: 4px\n}\n\n.tw-w-2 {\n  width: 8px\n}\n\n.tw-w-3 {\n  width: 12px\n}\n\n.tw-w-4 {\n  width: 16px\n}\n\n.tw-w-5 {\n  width: 20px\n}\n\n.tw-w-6 {\n  width: 24px\n}\n\n.tw-w-7 {\n  width: 28px\n}\n\n.tw-w-8 {\n  width: 32px\n}\n\n.tw-w-9 {\n  width: 36px\n}\n\n.tw-w-10 {\n  width: 40px\n}\n\n.tw-w-12 {\n  width: 48px\n}\n\n.tw-w-14 {\n  width: 56px\n}\n\n.tw-w-16 {\n  width: 64px\n}\n\n.tw-w-20 {\n  width: 80px\n}\n\n.tw-w-24 {\n  width: 96px\n}\n\n.tw-w-28 {\n  width: 112px\n}\n\n.tw-w-32 {\n  width: 128px\n}\n\n.tw-w-36 {\n  width: 144px\n}\n\n.tw-w-40 {\n  width: 160px\n}\n\n.tw-w-44 {\n  width: 176px\n}\n\n.tw-w-48 {\n  width: 192px\n}\n\n.tw-w-52 {\n  width: 208px\n}\n\n.tw-w-64 {\n  width: 256px\n}\n\n.tw-w-72 {\n  width: 288px\n}\n\n.tw-w-80 {\n  width: 320px\n}\n\n.tw-w-96 {\n  width: 384px\n}\n\n.tw-w-160 {\n  width: 640px\n}\n\n.tw-w-auto {\n  width: auto\n}\n\n.tw-w-px {\n  width: 1px\n}\n\n.tw-w-0\\.5 {\n  width: 2px\n}\n\n.tw-w-1\\/2 {\n  width: 50%\n}\n\n.tw-w-1\\/3 {\n  width: 33.333333%\n}\n\n.tw-w-1\\/4 {\n  width: 25%\n}\n\n.tw-w-3\\/4 {\n  width: 75%\n}\n\n.tw-w-1\\/5 {\n  width: 20%\n}\n\n.tw-w-2\\/5 {\n  width: 40%\n}\n\n.tw-w-3\\/5 {\n  width: 60%\n}\n\n.tw-w-4\\/5 {\n  width: 80%\n}\n\n.tw-w-1\\/6 {\n  width: 16.666667%\n}\n\n.tw-w-1\\/12 {\n  width: 8.333333%\n}\n\n.tw-w-2\\/12 {\n  width: 16.666667%\n}\n\n.tw-w-3\\/12 {\n  width: 25%\n}\n\n.tw-w-4\\/12 {\n  width: 33.333333%\n}\n\n.tw-w-6\\/12 {\n  width: 50%\n}\n\n.tw-w-11\\/12 {\n  width: 91.666667%\n}\n\n.tw-w-1\\/20 {\n  width: 5%\n}\n\n.tw-w-2\\/20 {\n  width: 10%\n}\n\n.tw-w-3\\/20 {\n  width: 15%\n}\n\n.tw-w-8\\/20 {\n  width: 40%\n}\n\n.tw-w-12\\/100 {\n  width: 12%\n}\n\n.tw-w-13\\/100 {\n  width: 13%\n}\n\n.tw-w-17\\/100 {\n  width: 17%\n}\n\n.tw-w-21\\/100 {\n  width: 21%\n}\n\n.tw-w-full {\n  width: 100%\n}\n\n.tw-w-90screen {\n  width: 90vw\n}\n\n.tw-z-0 {\n  z-index: 0\n}\n\n.tw-z-10 {\n  z-index: 10\n}\n\n.tw-z-30 {\n  z-index: 30\n}\n\n.tw-z-40 {\n  z-index: 40\n}\n\n.tw-z-50 {\n  z-index: 50\n}\n\n.tw-z-9998 {\n  z-index: 9998\n}\n\n.tw-z-10001 {\n  z-index: 10001\n}\n\n.tw-z-10002 {\n  z-index: 10002\n}\n\n.tw--z-10 {\n  z-index: -10\n}\n\n.tw-gap-1 {\n  grid-gap: 4px;\n  gap: 4px\n}\n\n.tw-gap-2 {\n  grid-gap: 8px;\n  gap: 8px\n}\n\n.tw-gap-3 {\n  grid-gap: 12px;\n  gap: 12px\n}\n\n.tw-gap-4 {\n  grid-gap: 16px;\n  gap: 16px\n}\n\n.tw-gap-5 {\n  grid-gap: 20px;\n  gap: 20px\n}\n\n.tw-gap-6 {\n  grid-gap: 24px;\n  gap: 24px\n}\n\n.tw-gap-x-1 {\n  grid-column-gap: 4px;\n  column-gap: 4px\n}\n\n.tw-gap-x-2 {\n  grid-column-gap: 8px;\n  column-gap: 8px\n}\n\n.tw-gap-x-4 {\n  grid-column-gap: 16px;\n  column-gap: 16px\n}\n\n.tw-gap-x-5 {\n  grid-column-gap: 20px;\n  column-gap: 20px\n}\n\n.tw-gap-y-4 {\n  grid-row-gap: 16px;\n  row-gap: 16px\n}\n\n.tw-grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr))\n}\n\n.tw-grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr))\n}\n\n.tw-grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr))\n}\n\n.tw-grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr))\n}\n\n.tw-transform {\n  --transform-translate-x: 0;\n  --transform-translate-y: 0;\n  --transform-rotate: 0;\n  --transform-skew-x: 0;\n  --transform-skew-y: 0;\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))\n}\n\n.tw-origin-right {\n  transform-origin: right\n}\n\n.tw-scale-50 {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5\n}\n\n.tw-rotate-45 {\n  --transform-rotate: 45deg\n}\n\n.tw-rotate-180 {\n  --transform-rotate: 180deg\n}\n\n.tw--translate-x-1\\/2 {\n  --transform-translate-x: -50%\n}\n\n.tw-translate-x-1\\/2 {\n  --transform-translate-x: 50%\n}\n\n.tw--translate-y-full {\n  --transform-translate-y: -100%\n}\n\n.tw--translate-y-1\\/2 {\n  --transform-translate-y: -50%\n}\n\n.tw-translate-y-1\\/2 {\n  --transform-translate-y: 50%\n}\n\n.tw-transition-all {\n  transition-property: all\n}\n\n.tw-transition-colors {\n  transition-property: background-color, border-color, color, fill, stroke\n}\n\n.tw-transition-opacity {\n  transition-property: opacity\n}\n\n.tw-transition-transform {\n  transition-property: transform\n}\n\n.tw-ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n\n.tw-duration-100 {\n  transition-duration: 100ms\n}\n\n.tw-duration-200 {\n  transition-duration: 200ms\n}\n\n.tw-duration-300 {\n  transition-duration: 300ms\n}\n\n.tw-duration-500 {\n  transition-duration: 500ms\n}\n\n.tw-duration-1000 {\n  transition-duration: 1000ms\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg)\n  }\n}\n\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0\n  }\n}\n\n@keyframes pulse {\n  50% {\n    opacity: .5\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8,0,1,1)\n  }\n\n  50% {\n    transform: none;\n    animation-timing-function: cubic-bezier(0,0,0.2,1)\n  }\n}\n\n@media (min-width: 640px) {\n  .sm\\:tw-flex-no-wrap {\n    flex-wrap: nowrap\n  }\n\n  .sm\\:tw-text-xs {\n    font-size: 12px;\n    line-height: 16px\n  }\n\n  .sm\\:tw-mr-4 {\n    margin-right: 16px\n  }\n\n  .sm\\:tw-w-24 {\n    width: 96px\n  }\n\n  .sm\\:tw-w-4\\/12 {\n    width: 33.333333%\n  }\n\n  .sm\\:tw-w-6\\/12 {\n    width: 50%\n  }\n\n  .sm\\:tw-grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:tw-text-base {\n    font-size: 16px;\n    line-height: 24px\n  }\n\n  .md\\:tw-w-64 {\n    width: 256px\n  }\n\n  .md\\:tw-w-3xl {\n    width: 768px\n  }\n\n  .md\\:tw-grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:tw-grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n  }\n}\n\n@media (min-width: 1280px) {\n}\n\n@media (min-width: 1366px) {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
